<template>
  <div id="tab-ams" class="ams-info">
    <!--ENS按钮：数据抄录/同步HBL信息/代码检索...-->
    <div v-if="showCodeSearch" class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-button :disabled="readonly" type="primary" @click="aiRecognitionHandler(true, pm.aiRecognitionPostHandlerByCargoDoc)">{{ this.getItemTitle('AI Recognition') }}</el-button>
          <el-button :disabled="readonly" type="primary" @click="linkOperationRequirement">{{ this.getItemTitle('Operation Requirement') }}</el-button>
          <el-dropdown
            style="padding-left: 5px;"
            :disabled="readonly"
            split-button
            type="primary"
            no="1"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ this.getItemTitle(command1) }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="Copy Last Time">{{ this.getItemTitle('Copy Last Time') }}</el-dropdown-item>
              <el-dropdown-item command="Copy By File NO">{{ this.getItemTitle('Copy By File NO') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!--分单信息/港口信息/关联方信息/下层申报人/集装箱信息/货物信息-->
    <div style="width: fit-content">
      <div style="display: flex" class="address-format-from">
        <div class="section form-column" style="width: 824px;">
          <!--分单信息-->
          <span class="title">{{ getItemTitle('HblInfo') }}</span>
          <el-form :disabled="readonly" label-width="110px" label-position="left" style="margin-left:18px;margin-right: 18px">
            <el-form-item label-width="0" class="auto-width">
              <cargo-ag-grid
                config-module="1001009"
                :grid-options="ams2.gridOptions"
                :column-defs="ams2ColumnDefs"
                :row-data="ams2.rowData"
                style="width:100%;height:200px"
                @gridReady="params=>{ams2.gridApi=params.api}"
              />
              <div style="padding:5px 0">
                <div style="float:right">
                  <el-button type="primary" :title="$t('SeaExport.addHbl')" no="5" @click="pm.btnAddHblHandler()">{{ getItemTitle('Add HB/L') }}</el-button>
                  <el-button type="primary" :title="$t('SeaExport.SynchronizeHBLInformation')" no="2" @click="pm.btnSynchroClickHandlerByNewEns()">{{ getItemTitle('Import HB/L') }}</el-button>
                  <el-button type="danger" :title="$t('SeaExport.Delete')" no="4" @click="pm.onRemoveCargoDocAi()">{{ getItemTitle('Delete') }}</el-button>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <!--ENS申报信息--->
          <span class="title" style="margin-top: 46px">{{ 'ENS '+$t('SeaExport.DeclarationInformation') }}</span>
          <el-form :disabled="readonly" label-width="110px" label-position="left" style="margin-left:18px;margin-right: 18px">
            <!--ENS申报信息-报文类型-->
            <el-form-item class="blue-text" :label="getEnsInfoAITitle('Filing Type')">
              <el-select v-model="form.declarationType" :disabled="readonly || isTradetech" no="declarationType">
                <el-option :label="isChineseLanguage ? 'F14  |  有签发HBL，不含真实买卖方的HBL数据' : 'F14  |  HBL data without seller & buyer Issue HBL'" value="F14" />
                <el-option :label="isChineseLanguage ? 'F15  |  有签发HBL，包含真实收发通和买卖方的完整HBL数据' : 'F15  |  Complete HBL data with all actors Issue HBL'" value="F15" />
                <el-option :label="isChineseLanguage ? 'F16  |  有签发HBL，真实买卖方HBL补充数据' : 'F16  |  HBL supplementary data of seller & buyer Issue HBL'" value="F16" />
                <el-option :label="isChineseLanguage ? 'F17  |  不签发HBL，真实买卖方MBL补充数据' : 'F17  |  MBL supplementary data of seller & buyer Direct BL'" value="F17" />
              </el-select>
            </el-form-item>
            <!--ENS申报信息-船公司-->
            <el-form-item class="blue-text" :label="getEnsInfoAITitle('Carrier')">
              <cargo-advance-select
                no="carrierEori"
                :static-options="shipCompanyInfos"
                :filter-tag-names="['carrierEori', 'shipCompanyCode', 'shipCompanyEnglishName', 'shipCompanyChineseName']"
                :cache="false"
                filterable
                tag-value="carrierEori"
                :default-value="form.carrierEori"
                :show-custom-label-in-option="true"
                :custom-label="(item) => customLabelHandler('Carrier', item)"
                @parentCallBack="carrierEoriChange"
              />
            </el-form-item>
            <!--ENS申报信息-申报人-->
            <el-form-item class="blue-text" :label="getEnsInfoAITitle('Declarant')">
              <cargo-advance-select
                no="declarantEori"
                :static-options="localData.officeEoriList"
                :cache="false"
                filterable
                tag-value="eori"
                :default-value="form.declarantEori"
                :show-custom-label-in-option="true"
                :custom-label="(item) => customLabelHandler('Declarant', item)"
                @parentCallBack="declarantEoriChange"
              />
            </el-form-item>
            <!--ENS申报信息-第一欧盟入境国-->
            <el-form-item class="blue-text" :label="getEnsInfoAITitle('Memberstate')">
              <cargo-advance-select
                no="8"
                :static-options="declaringCountrys"
                :cache="false"
                :default-value="form.declaringMemberCountry"
                filterable
                clearable
                :filter-tag-names="['code']"
                tag-name="code"
                tag-value="code"
                :show-custom-label-in-option="true"
                :custom-label="(item) => customLabelHandler('Memberstate', item)"
                @parentCallBack="p=>{form.declaringMemberCountry = p.value}"
              />
            </el-form-item>
            <!--ENS申报信息-运输类型 -->
            <el-form-item class="blue-text" :label="getEnsInfoAITitle('Declare Type')">
              <cargo-advance-select
                no="chargesPaymentMethod"
                :static-options="SystemConstants.AMS_ENS_TRANSPORT_TYPES_AI"
                :cache="false"
                :default-value="form.frob"
                tag-name="chineseName"
                tag-value="code"
                :show-custom-label-in-option="true"
                :custom-label="(item) => customLabelHandler('Declare Type', item)"
                @parentCallBack="p=>{form.frob = p.value}"
              />
            </el-form-item>
            <!--ENS申报信息-主单号-->
            <el-form-item>
              <span slot="label" class="blue-text">{{ getEnsInfoAITitle('MB/L NO') }}</span>
              <el-input v-model="form.mbl" :disabled="readonly" no="mbl" />
            </el-form-item>
            <!--ENS申报信息-付款方式-->
            <el-form-item :class="isDifferent(true, true, false)" :label="getEnsInfoAITitle('Payment Method')">
              <cargo-advance-select
                no="chargesPaymentMethod"
                :static-options="SystemConstants.AMS_ENS_PAYMENT_METHODS"
                :cache="false"
                :default-value="form.chargesPaymentMethod"
                tag-name="chineseName"
                tag-value="code"
                :show-custom-label-in-option="true"
                :custom-label="(item) => customLabelHandler('Payment Method', item)"
                @parentCallBack="p=>{form.chargesPaymentMethod = p.value}"
              />
            </el-form-item>
          </el-form>
          <!--港口信息-->
          <span class="title" style="margin-top: 46px" :title="'ENS '+$t('SeaExport.PortInformation')">{{ getItemTitle('Port Information') }}</span>
          <el-form :disabled="readonly" label-width="110px" label-position="left" style="margin-left:18px;margin-right: 18px">
            <!--港口信息-起运港-->
            <el-form-item :label="getEnsInfoAITitle('Place of Loading')" :class="isDifferent(true, true,true)">
              <cargo-advance-select
                no="loadingPortCode"
                filterable
                :select-type="TYPE_NAMES.basic_data_Seaport"
                :default-value="form.loadingPortCode"
                tag-name="englishName"
                :show-custom-label-in-option="true"
                :custom-label="(item) => customLabelHandler('Place of Loading', item)"
                @parentCallBack="p=>{portChange(p, 'loadingPortCode', 'loadingPort')}"
              />
            </el-form-item>
            <!--港口信息-目的港-->
            <el-form-item :label="getEnsInfoAITitle('Place of Discharge')" :class="isDifferent(true, true,true)">
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode||''"
                tag-name="englishName"
                no="dischargingPortCode"
                :show-custom-label-in-option="true"
                :custom-label="(item) => customLabelHandler('Place of Loading', item)"
                @parentCallBack="p=>{portChange(p, 'dischargingPortCode', 'dischargingPort')}"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column" style="width: 824px;">
          <!--关联方信息-->
          <span class="title">{{ getItemTitle('Related Information') }}</span>
          <div v-show="!isF16F17">
            <el-form :disabled="readonly" label-width="110px" label-position="left" style="margin-left:18px;margin-right: 18px">
              <!--关联方信息-发货人-->
              <el-form-item>
                <span slot="label" :class="isDifferent(true, true,true)">{{ getEnsInfoAITitle('Shipper') }}</span>
                <cargo-company-select
                  no="shipperCode"
                  :method-params="{shipper:true,active:true}"
                  :default-value="addressForm.shipperCode||''"
                  style="display: inline-block;width:359px;margin-right: 5px"
                  :allow-create="true"
                  placeholder=" "
                  @change="val => {shipperChange(val)}"
                />&nbsp;
                <el-checkbox v-show="isF15" v-model="addressForm.copyToSeller">{{ $t('SeaExport.CopyToSeller') }}</el-checkbox>
                <el-button no="shipperBtnAiRecognition" type="primary" style="vertical-align: top;margin-left: 27px" @click="aiRecognitionHandler(false, aiRecognitionPostHandlerByShipper, SystemConstants.AMS_ENS_PROMPT_KEY_ADDRESS.code)">{{ getItemTitle('Ai Recognition') }}</el-button>
                <el-button no="shipperBtnCodeSearching" type="primary" style="vertical-align: top;margin-left: 27px !important" @click="billAddressDialog.visible=true">{{ $t('SeaExport.CodeSearching') }}</el-button>
              </el-form-item>
              <el-form-item>
                <span slot="label" :class="isDifferent(true, true,true, true)">{{ getEnsInfoAITitle('name') }}</span>
                <el-input v-model="addressForm.shipperLine1" :filter-chars="false" no="shipperLine1" />
              </el-form-item>
              <el-form-item>
                <span slot="label" :class="isDifferent(true, true,true, true)">{{ getEnsInfoAITitle('Address1') }}</span>
                <el-input v-model="addressForm.shipperLine3" :filter-chars="false" no="shipperLine3" />
              </el-form-item>
              <el-form-item>
                <span slot="label">{{ getEnsInfoAITitle('Address2') }}</span>
                <el-input v-model="addressForm.shipperLine4" :filter-chars="false" no="shipperLine4" />
              </el-form-item>
              <el-form-item>
                <span slot="label" style="color: #1f75d5 !important;" :title="$t('SeaExport.HouseNumber')">{{ getEnsInfoAITitle('No.') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-input v-model="addressForm.shipperStreetNo" :disabled="form.noHouseNumberByShipper" no="shipperStreetNo" style="flex: 1;" />
                    <el-checkbox v-model="form.noHouseNumberByShipper" style="margin-left: 25px" @change="(newVal) => {updateStreetNoBynoHouseNumberHandler(newVal, 'shipper')}">{{ $t('SeaExport.NoHouseNumber') }}</el-checkbox>
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label blue-text" :title="$t('SeaExport.ZIP')">{{ getEnsInfoAITitle('ZIP') }}</span>
                    <el-input v-model="addressForm.shipperPostalcode" :class="zipMaxLength(addressForm.shipperPostalcode)" no="shipperPostalcode" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label" style="color: #1f75d5 !important;" :title="$t('SeaExport.City')">{{ getEnsInfoAITitle('City') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-input v-model="addressForm.shipperCity" :class="cityMaxLength(addressForm.shipperCity)" no="shipperCity" />
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label" style="color: #1f75d5 !important;" :title="$t('SeaExport.Country')">{{ getEnsInfoAITitle('Country') }}</span>
                    <el-select
                      v-model="addressForm.shipperCountry"
                      filterable
                      clearable
                      placeholder=" "
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in countryList"
                        :key="item.code"
                        :label="customLabelHandler('Country', item)"
                        :value="item.code"
                      />
                    </el-select>
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label" :title="$t('SeaExport.Tel')">{{ getEnsInfoAITitle('Tel') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-input v-model="addressForm.shipperTel" :class="telMaxLength(addressForm.shipperTel)" no="shipperTel" />
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label" :title="$t('SeaExport.Email')">{{ getEnsInfoAITitle('E-mail') }}</span>
                    <el-input v-model="addressForm.shipperEmail" :class="emailMaxLength(addressForm.shipperEmail)" no="shipperEmail" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label">{{ getEnsInfoAITitle('Type') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-select v-model="addressForm.shipperTypeOfPerson" no="shipperTypeOfPerson" placeholder="">
                      <el-option :label="isChineseLanguage ? 'Legal person | 法人' : 'Legal person'" value="1" />
                      <el-option :label="isChineseLanguage ? 'Natural person  |  自然人' : 'Natural person'" value="2" />
                      <el-option :label="isChineseLanguage ? 'Association of persons  |  协会团体' : 'Association of persons'" value="3" />
                    </el-select>
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label" title="EORI">{{ getEnsInfoAITitle('EORI') }}</span>
                    <el-input v-model="addressForm.shipperEori" no="shipperEori" />
                  </div>
                </div>
              </el-form-item>
              <!--关联方信息-收货人-->
              <el-form-item style="margin-top: 20px">
                <span slot="label" :class="isDifferent(true, true,true)">{{ getEnsInfoAITitle('Consignee') }}</span>
                <cargo-company-select
                  no="shipperCode"
                  :method-params="{shipper:true,active:true}"
                  :default-value="addressForm.consigneeCode||''"
                  style="display: inline-block;width:359px;margin-right: 5px"
                  :allow-create="true"
                  placeholder=" "
                  @change="val => {consigneeChange(val)}"
                />&nbsp;
                <el-checkbox v-show="isF15" v-model="addressForm.copyToBuyer">{{ $t('SeaExport.CopyToBuyer') }}</el-checkbox>
                <el-button no="consigneeBtnAiRecognition" type="primary" style="vertical-align: top;margin-left: 27px" @click="aiRecognitionHandler(false, aiRecognitionPostHandlerByConsignee, SystemConstants.AMS_ENS_PROMPT_KEY_ADDRESS.code)">{{ getItemTitle('Ai Recognition') }}</el-button>
                <el-button no="shipperBtnCodeSearching" type="primary" style="vertical-align: top;margin-left: 27px !important" @click="billAddressDialog.visible=true">{{ $t('SeaExport.CodeSearching') }}</el-button>
              </el-form-item>
              <el-form-item :title="$t('SeaExport.CompanyTitle')">
                <span slot="label" :class="isDifferent(true, true,true, true)">{{ getEnsInfoAITitle('name') }}</span>
                <el-input v-model="addressForm.consigneeLine1" :filter-chars="false" no="consigneeLine1" />
              </el-form-item>
              <el-form-item>
                <span slot="label" :class="isDifferent(true, true,true, true)">{{ getEnsInfoAITitle('Address1') }}</span>
                <el-input v-model="addressForm.consigneeLine3" :filter-chars="false" no="consigneeLine3" />
              </el-form-item>
              <el-form-item :title="$t('SeaExport.Addr') + '2'">
                <span slot="label">{{ getEnsInfoAITitle('Address2') }}</span>
                <el-input v-model="addressForm.consigneeLine4" :filter-chars="false" no="consigneeLine4" />
              </el-form-item>
              <el-form-item>
                <span slot="label" style="color: #1f75d5 !important;" :title="$t('SeaExport.HouseNumber')">{{ getEnsInfoAITitle('No.') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-input v-model="addressForm.consigneeStreetNo" :disabled="form.noHouseNumberByConsignee" no="consigneeStreetNo" style="flex: 1;" />
                    <el-checkbox v-model="form.noHouseNumberByConsignee" style="margin-left: 25px" @change="(newVal) => {updateStreetNoBynoHouseNumberHandler(newVal, 'consignee')}">{{ $t('SeaExport.NoHouseNumber') }}</el-checkbox>
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label blue-text" :title="$t('SeaExport.ZIP')">{{ getEnsInfoAITitle('ZIP') }}</span>
                    <el-input v-model="addressForm.consigneePostalcode" :class="zipMaxLength(addressForm.consigneePostalcode)" no="consigneePostalcode" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label" style="color: #1f75d5 !important;" :title="$t('SeaExport.City')">{{ getEnsInfoAITitle('City') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-input v-model="addressForm.consigneeCity" :class="cityMaxLength(addressForm.consigneeCity)" no="consigneeCity" />
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label" style="color: #1f75d5 !important;" :title="$t('SeaExport.Country')">{{ getEnsInfoAITitle('Country') }}</span>
                    <el-select
                      v-model="addressForm.consigneeCountry"
                      filterable
                      clearable
                      placeholder=" "
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in countryList"
                        :key="item.code"
                        :label="customLabelHandler('Country', item)"
                        :value="item.code"
                      />
                    </el-select>
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label" :title="$t('SeaExport.Tel')">{{ getEnsInfoAITitle('Tel') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-input v-model="addressForm.consigneeTel" :class="telMaxLength(addressForm.consigneeTel)" no="consigneeTel" />
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label" :title="$t('SeaExport.Email')">{{ getEnsInfoAITitle('E-mail') }}</span>
                    <el-input v-model="addressForm.consigneeEmail" :class="emailMaxLength(addressForm.consigneeEmail)" no="consigneeEmail" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label">{{ getEnsInfoAITitle('Type') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-select v-model="addressForm.consigneeTypeOfPerson" no="consigneeTypeOfPerson" placeholder="">
                      <el-option :label="isChineseLanguage ? 'Legal person | 法人' : 'Legal person'" value="1" />
                      <el-option :label="isChineseLanguage ? 'Natural person  |  自然人' : 'Natural person'" value="2" />
                      <el-option :label="isChineseLanguage ? 'Association of persons  |  协会团体' : 'Association of persons'" value="3" />
                    </el-select>
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label" title="EORI">{{ getItemTitle('ADDRESS EORI') }}</span>
                    <el-input v-model="addressForm.consigneeEori" no="consigneeEori" />
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <!--展开卖方/买方-->
          <div v-show="isF15" style="display: flex; justify-content: right; color: #1f75d5 !important;margin-top: 10px;margin-right: 15px;cursor: pointer" @click="expandSellerBuyer()">
            <span>{{ $t('SeaExport.ExpandSellerBuyer') }}</span>
            <img :style="showSellerBuyer ? 'transform: rotate(180deg)' : ''" src="@/assets/icons/address-expand.png" alt="">
          </div>
          <!--关联方信息-买卖方信息-->
          <div v-show="(isF15 && showSellerBuyer) || isF16F17">
            <el-form :disabled="readonly" label-width="110px" label-position="left" style="margin-left:18px;margin-right: 18px">
              <!--关联方信息-卖方-->
              <el-form-item>
                <span slot="label" :class="isDifferent(true, true,true)">{{ getEnsInfoAITitle('Seller') }}</span>
                <cargo-company-select
                  no="shipperCode"
                  :method-params="{shipper:true,active:true}"
                  :default-value="addressForm.shipperCode||''"
                  style="display: inline-block;width:359px;margin-right: 5px"
                  :allow-create="true"
                  placeholder=" "
                  @change="val => {sellerChange(val)}"
                />&nbsp;
                <el-button no="sellerBtnAiRecognition" type="primary" style="vertical-align: top;margin-left: 27px" @click="aiRecognitionHandler(false, aiRecognitionPostHandlerBySeller, SystemConstants.AMS_ENS_PROMPT_KEY_ADDRESS.code)">{{ getItemTitle('Ai Recognition') }}</el-button>
                <el-button v-show="!isF16F17" no="shipperBtnCodeSearching" type="primary" style="vertical-align: top;margin-left: 27px !important" @click="billAddressDialog.visible=true">{{ $t('SeaExport.CodeSearching') }}</el-button>
              </el-form-item>
              <el-form-item>
                <span slot="label" :class="isDifferent(true, true,true, true)">{{ getEnsInfoAITitle('name') }}</span>
                <el-input v-model="addressForm.sellerName" :filter-chars="false" no="sellerName" />
              </el-form-item>
              <el-form-item>
                <span slot="label" :class="isDifferent(true, true,true, true)">{{ getEnsInfoAITitle('Address1') }}</span>
                <el-input v-model="addressForm.sellerAddress1" :filter-chars="false" no="sellerAddress1" />
              </el-form-item>
              <el-form-item>
                <span slot="label">{{ getEnsInfoAITitle('Address2') }}</span>
                <el-input v-model="addressForm.sellerAddress2" :filter-chars="false" no="sellerAddress2" />
              </el-form-item>
              <el-form-item>
                <span slot="label" style="color: #1f75d5 !important;" :title="$t('SeaExport.HouseNumber')">{{ getEnsInfoAITitle('No.') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-input v-model="addressForm.sellerStreetNo" :disabled="form.noHouseNumberBySeller" no="sellerStreetNo" style="flex: 1;" />
                    <el-checkbox v-model="form.noHouseNumberBySeller" style="margin-left: 25px" @change="(newVal) => {updateStreetNoBynoHouseNumberHandler(newVal, 'seller')}">{{ $t('SeaExport.NoHouseNumber') }}</el-checkbox>
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label blue-text" :title="$t('SeaExport.ZIP')">{{ getEnsInfoAITitle('ZIP') }}</span>
                    <el-input v-model="addressForm.sellerPostalcode" :class="zipMaxLength(addressForm.sellerPostalcode)" no="sellerPostalcode" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label" style="color: #1f75d5 !important;" :title="$t('SeaExport.City')">{{ getEnsInfoAITitle('City') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-input v-model="addressForm.sellerCity" :class="cityMaxLength(addressForm.sellerCity)" no="sellerCity" />
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label" style="color: #1f75d5 !important;" :title="$t('SeaExport.Country')">{{ getEnsInfoAITitle('Country') }}</span>
                    <el-select
                      v-model="addressForm.sellerCountry"
                      filterable
                      clearable
                      placeholder=" "
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in countryList"
                        :key="item.code"
                        :label="customLabelHandler('Country', item)"
                        :value="item.code"
                      />
                    </el-select>
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label" :title="$t('SeaExport.Tel')">{{ getEnsInfoAITitle('Tel') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-input v-model="addressForm.sellerTel" :class="telMaxLength(addressForm.sellerTel)" no="sellerTel" />
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label" :title="$t('SeaExport.Email')">{{ getEnsInfoAITitle('E-mail') }}</span>
                    <el-input v-model="addressForm.sellerEmail" :class="emailMaxLength(addressForm.sellerEmail)" no="sellerEmail" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label">{{ getEnsInfoAITitle('Type') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-select v-model="addressForm.sellerTypeOfPerson" no="sellerTypeOfPerson" placeholder="">
                      <el-option :label="isChineseLanguage ? 'Legal person | 法人' : 'Legal person'" value="1" />
                      <el-option :label="isChineseLanguage ? 'Natural person  |  自然人' : 'Natural person'" value="2" />
                      <el-option :label="isChineseLanguage ? 'Association of persons  |  协会团体' : 'Association of persons'" value="3" />
                    </el-select>
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label" title="EORI">{{ getItemTitle('ADDRESS EORI') }}</span>
                    <el-input v-model="addressForm.sellerEori" no="sellerEori" />
                  </div>
                </div>
              </el-form-item>
              <!--关联方信息-买方-->
              <el-form-item style="margin-top: 20px">
                <span slot="label" :class="isDifferent(true, true,true)">{{ getEnsInfoAITitle('Buyer') }}</span>
                <cargo-company-select
                  no="shipperCode"
                  :method-params="{shipper:true,active:true}"
                  :default-value="addressForm.shipperCode||''"
                  style="display: inline-block;width:359px;margin-right: 5px"
                  :allow-create="true"
                  placeholder=" "
                  @change="val => {buyerChange(val)}"
                />&nbsp;
                <el-button no="buyerBtnAiRecognition" type="primary" style="vertical-align: top;margin-left: 27px" @click="aiRecognitionHandler(false, aiRecognitionPostHandlerByBuyer, SystemConstants.AMS_ENS_PROMPT_KEY_ADDRESS.code)">{{ getItemTitle('Ai Recognition') }}</el-button>
                <el-button v-show="!isF16F17" no="shipperBtnCodeSearching" type="primary" style="vertical-align: top;margin-left: 27px !important" @click="billAddressDialog.visible=true">{{ $t('SeaExport.CodeSearching') }}</el-button>
              </el-form-item>
              <el-form-item :title="$t('SeaExport.CompanyTitle')">
                <span slot="label" :class="isDifferent(true, true,true, true)">{{ getEnsInfoAITitle('name') }}</span>
                <el-input v-model="addressForm.buyerName" :filter-chars="false" no="buyerName" />
              </el-form-item>
              <el-form-item>
                <span slot="label" :class="isDifferent(true, true,true, true)">{{ getEnsInfoAITitle('Address1') }}</span>
                <el-input v-model="addressForm.buyerAddress1" :filter-chars="false" no="buyerAddress1" />
              </el-form-item>
              <el-form-item>
                <span slot="label">{{ getEnsInfoAITitle('Address2') }}</span>
                <el-input v-model="addressForm.buyerAddress2" :filter-chars="false" no="buyerAddress2" />
              </el-form-item>
              <el-form-item>
                <span slot="label" style="color: #1f75d5 !important;" :title="$t('SeaExport.HouseNumber')">{{ getEnsInfoAITitle('No.') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-input v-model="addressForm.buyerStreetNo" :disabled="form.noHouseNumberByBuyer" no="buyerStreetNo" />
                    <el-checkbox v-model="form.noHouseNumberByBuyer" style="margin-left: 25px" @change="(newVal) => {updateStreetNoBynoHouseNumberHandler(newVal, 'buyer')}">{{ $t('SeaExport.NoHouseNumber') }}</el-checkbox>
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label blue-text" :title="$t('SeaExport.ZIP')">{{ getEnsInfoAITitle('ZIP') }}</span>
                    <el-input v-model="addressForm.buyerPostalcode" :class="zipMaxLength(addressForm.buyerPostalcode)" no="buyerPostalcode" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label" style="color: #1f75d5 !important;" :title="$t('SeaExport.City')">{{ getEnsInfoAITitle('City') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-input v-model="addressForm.buyerCity" :class="cityMaxLength(addressForm.buyerCity)" no="buyerCity" />
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label" style="color: #1f75d5 !important;" :title="$t('SeaExport.Country')">{{ getEnsInfoAITitle('Country') }}</span>
                    <el-select
                      v-model="addressForm.buyerCountry"
                      filterable
                      clearable
                      placeholder=" "
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in countryList"
                        :key="item.code"
                        :label="customLabelHandler('Country', item)"
                        :value="item.code"
                      />
                    </el-select>
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label" :title="$t('SeaExport.Tel')">{{ getEnsInfoAITitle('Tel') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-input v-model="addressForm.buyerTel" :class="telMaxLength(addressForm.buyerTel)" no="buyerTel" />
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label" :title="$t('SeaExport.Email')">{{ getEnsInfoAITitle('E-mail') }}</span>
                    <el-input v-model="addressForm.buyerEmail" :class="emailMaxLength(addressForm.buyerEmail)" no="buyerEmail" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label">{{ getEnsInfoAITitle('Type') }}</span>
                <div style="display: flex; justify-content: space-between;">
                  <div style="display: flex; align-items: center; width: 35%;">
                    <el-select v-model="addressForm.buyerTypeOfPerson" no="buyerTypeOfPerson" placeholder="">
                      <el-option :label="isChineseLanguage ? 'Legal person | 法人' : 'Legal person'" value="1" />
                      <el-option :label="isChineseLanguage ? 'Natural person  |  自然人' : 'Natural person'" value="2" />
                      <el-option :label="isChineseLanguage ? 'Association of persons  |  协会团体' : 'Association of persons'" value="3" />
                    </el-select>
                  </div>
                  <div style="display: flex; align-items: center; width: 50%;">
                    <span class="center-label" title="EORI">{{ getItemTitle('ADDRESS EORI') }}</span>
                    <el-input v-model="addressForm.buyerEori" no="buyerEori" />
                  </div>
                </div>
              </el-form-item>
            </el-form>
            <div style="margin-bottom: 10px;" />
          </div>
          <!--下层申报人-->
          <div v-show="isF14">
            <div style="display: flex;margin-top: 46px;justify-content: left;align-items: center;gap: 10px;">
              <span class="title" :title="$t('SeaExport.SubstratumDeclarant')">{{ getItemTitle('Substratum Declarant') }}</span>
              <el-button :disabled="readonly" style="margin-bottom: 10px" size="mini" type="primary" @click="addRouteCountry2">{{ $t('Partners.btnAdd') }}</el-button>
              <el-button :disabled="readonly" style="margin-bottom: 10px" size="mini" type="danger" @click="deleteRouteCountry2">{{ $t('Partners.btnRemove') }}</el-button>
            </div>
            <cargo-ag-grid
              config-module="131703"
              :grid-options="coloadInSelfFilingIndicator.gridOptions"
              :column-defs="columnDefs2"
              :row-data="form.ensDeclarationData"
              style="width:100%;"
              @gridReady="params=>{gridApi2=params.api}"
            />
          </div>
        </div>
      </div>
      <!--装箱信息-->
      <div v-show="!isF16F17" class="section">
        <span class="title" :title="$t('SeaExport.ContainerInformation')">{{ getItemTitle('House Container Information') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit" style="padding:5px 0">
            <el-button type="primary" :title="$t('SeaExport.AddContainerInformation')" no="71" @click="cargoDocUsageSelectedDialog.visible=true">{{ getItemTitle('Import Container No') }}</el-button>
            <el-button type="primary" :title="$t('SeaExport.AddContainerInformation')" no="89" @click="addContainerUsageClickHandler">{{ getItemTitle('Add Container No') }}</el-button>
            <el-button type="danger" :title="$t('SeaExport.RemoveContainerInformation')" no="72" @click="removeContainerUsageClickHandler">{{ getItemTitle('Delete') }}</el-button>
            <el-button type="primary" :title="$t('SeaExport.AiRecognition')" no="90" @click="aiRecognitionHandler(false, aiRecognitionPostHandlerByCargo, SystemConstants.AMS_ENS_PROMPT_KEY_CARGO.code)">{{ getItemTitle('Ai Recognition') }}</el-button>
          </div>
          <cargo-ag-grid
            config-module="131704"
            :grid-options="container.gridOptions"
            :column-defs="containerColumnDefs"
            :row-data="containerFinalRowData"
            style="width:100%;height:350px"
            @gridReady="params=>{container.gridApi=params.api}"
          />
        </div>
      </div>
      <!--货物信息-->
      <div v-show="!isF16F17" class="section">
        <span class="title" :title="$t('SeaExport.CargoInfo')">{{ getItemTitle('Cargo Information') }}</span>
        <div style="display:flex;flex-direction:column">
          <div style="padding:5px 0">
            <el-button v-show="isEdit" type="primary" :title="$t('SeaExport.AddContainerInformation')" no="69" @click="addCargoInfo">{{ getItemTitle('Add Description') }}</el-button>
            <el-button v-show="isEdit" type="danger" :title="$t('SeaExport.RemoveContainerInformation')" no="70" @click="deleteCargoInfo">{{ getItemTitle('Delete') }}</el-button>
            <el-button v-show="isEdit" type="primary" :title="$t('SeaExport.AiRecognition')" no="91" @click="aiRecognitionHandler(false, aiRecognitionPostHandlerByCargo, SystemConstants.AMS_ENS_PROMPT_KEY_CARGO.code)">{{ getItemTitle('Ai Recognition') }}</el-button>
            <el-button v-show="isEdit" type="primary" :title="$t('SeaExport.Query') + ' HS Code'" no="92" @click="navigateToLink('Query HS Code')">{{ getItemTitle('Query HS Code') }}</el-button>
            <el-button v-show="isEdit" type="primary" :title="$t('SeaExport.Query') + ' CUS No'" no="93" @click="navigateToLink('Query CUS No')">{{ getItemTitle('Query CUS No') }}</el-button>
            <span style="float: right">
              {{ $t('CargoMsg.Cargo_AmountToP') }}
              <span style="color: #1D6ACF;">
                {{ calculatedTotals.quantity }}
              </span>
              {{ $t('SeaExport.itemCount') }}
              <span style="color: #1D6ACF;">
                {{ calculatedTotals.weight }}
              </span>
              {{ $t('SeaExport.kilogram') }}
            </span>
          </div>
          <cargo-ag-grid
            config-module="131705"
            :grid-options="cargoInfomation.gridOptions"
            :column-defs="cargoInformationColumnDefs"
            :row-data="form.ensCargoInfo"
            style="width:100%;height:350px"
            @gridReady="params=>{gridApi3=params.api}"
          />
        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :warning-count="advanceTextDialog.warningCount"
        :disabled="readonly"
        style="height: 198px;"
        no="73"
      />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" no="74" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="75"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 回执信息弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="receiptInfoDialog.visible"
      :title="receiptInfoDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="receiptInfoDialog.gridOptions"
        :column-defs="receiptInfoDialog.columnDefs"
        :row-data="receiptInfoDialog.rowData"
        style="height:350px"
        @gridReady="params=>{receiptInfoDialog.gridApi=params.api}"
      />
    </el-dialog>
    <!-- 选择装箱信息弹窗 -->
    <cargo-doc-usage-selected-dialog
      :visible.sync="cargoDocUsageSelectedDialog.visible"
      :job="job"
      :doc-type="CargoDocConsts.AMS"
      @callback="cargoDocUsageSelectedDialog.callback"
    />
    <!-- AMS日志弹窗 -->
    <ams-log-view-title-dialog
      :visible.sync="amsLogViewTitleDialog.visible"
      :row-data="amsLogViewTitleDialog.rowData"
    />
    <!-- 单号抄录弹窗 -->
    <afr-address-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      :no-label="amsTitle"
      :no-title="amsTitleCn"
      @selected="p=>{pm.selectionItemHandler(p)}"
    />
    <!--校验弹框提示-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="checkDialog.visible"
      :title="checkDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="checkDialog.gridOptions"
        :column-defs="checkDialog.columnDefs"
        :row-data="checkDialog.rowData"
        :show-side-bar="false"
        style="height:350px"
        @gridReady="params=>{checkDialog.gridApi=params.api}"
      />
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      @callback="codeSearchCallback"
    />
    <!-- AI识别弹窗 -->
    <cargo-ai-recognition-dialog
      :visible.sync="aiRecognitionDialog.visible"
      :multimodal="aiRecognitionDialog.multimodal"
      :job-uuid="aiRecognitionDialog.jobUuid"
      :doc-uuid="aiRecognitionDialog.docUuid"
      :hbl-nbr2="aiRecognitionDialog.hblNbr2"
      :source="aiRecognitionDialog.source"
      :prompt-key="aiRecognitionDialog.promptKey"
      page-source="customsInfo"
      :i-channel="aiRecognitionDialog.iChannel"
      :call-back="aiRecognitionDialog.callBack"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import BillAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoDocUsageSelectedDialog from '@/components/Cargo/Job/cargoDocUsageSelectedDialog'
import amsLogViewTitleDialog from '@/components/Cargo/Job/amsLogViewTitleDialog'
import searchBillNoDialog from '@/views/cargo/v0/SeaExport/components/edi/searchBillNoDialog'
import selectSubLocDialog from '@/views/cargo/v0/SeaExport/components/booking/selectSubLocDialog'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAiRecognitionDialog from '@/views/cargo/v0/SeaExport/components/booking/ams/cargoAiRecognitionDialog.vue'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import EnsAddressFormatForm from '@/views/cargo/v0/SeaExport/components/booking/ams/form/ensAddressFormatForm'
import AfrAddressDialog from '@/components/Cargo/Job/afrAddressDialog'
import StrUtils from '@/utils/StrUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { getCacheListByKey, getObjectByCacheMatchFiled, getSpecificBasicData } from '@/utils/basicDataCache'
import AgGridColumnEdit from '@/components/Cargo/grid/agGridColumnEdit'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index'
import UIDUtil from '@/utils/uidUtil'
import { EQ_SIZES } from '@/class/cargo/model/parameters/EQSize'
import CargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import { Company } from '@/class/model/mdm/Company'
import { basicCacheKeys } from '@/utils/cacheConfig'
import ContainerNoHelper from '@/utils/containerNoHelper'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import { EDIContainer } from '@/class/model/booking/EDIContainer'
import * as NumberUtils from '@/utils/NumberUtils'

export default {
  name: 'EnsInfoAi',
  components: {
    CargoCompanySelect,
    AfrAddressDialog,
    EnsAddressFormatForm,
    CargoRichTextarea, AutoNumberInput,
    cargoAdvanceSelect, cargoInput, cargoPackingSelect, cargoDocUsageSelectedDialog, selectSubLocDialog,
    amsLogViewTitleDialog, searchBillNoDialog, BillAddressDialog,
    CargoAiRecognitionDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    tabName: {
      type: String,
      required: true
    },
    ams2: { type: Object, default: () => {} },
    container: { type: Object, default: () => {} },
    form: { type: Object, default: () => {} },
    pm: { type: Object, default: () => {} },
    localData: { type: Object, default: () => {} },
    showCodeSearch: { type: Boolean, default: false },
    showSecondNotifyParty: { type: Boolean, default: false },
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    return {
      aiRecognitionDialog: {
        multimodal: false, // 多模态模式，true-多模态支持上传文件;false-仅文本上传
        jobUuid: '',
        docUuid: '',
        hblNbr2: '',
        source: 0,
        pageSource: '',
        iChannel: 0,
        callBack: null,
        visible: false,
        promptKey: ''
      },
      SystemConstants,
      URL,
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      moment,
      TYPE_NAMES,
      CargoDocConsts,
      CargoDocUtil,
      isUppercase: false,
      command1: 'Copy Last Time',
      consignmentTypes: ['FCL', 'LCL'],
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        warningCount: 1000,
        showContact: false,
        extendData: {
          contact: '',
          mobile: '',
          fax: '',
          email: '',
          zipCode: '',
          city: ''
        },
        successCallback: null,
        isUppercase: false,
        formatObj: {
          maxChar: 45
        }
      },
      receiptInfoDialog: {
        visible: false,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.receiptDate'),
            colId: 'receiptDate',
            field: 'receiptDate',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.receiptCode'),
            colId: 'receiptCode',
            field: 'receiptCode',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.Content'),
            colId: 'receiptContent',
            field: 'receiptContent',
            width: 100
          }
        ],
        rowData: [],
        gridApi: null
      },
      checkDialog: {
        visible: false,
        title: this.$t('SeaExport.VerificationPrompt'),
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.Field'),
            field: 'field',
            width: 250
          },
          {
            headerName: this.$t('SeaExport.ErrorDescription'),
            field: 'errorDescription',
            width: 325
          }
        ],
        rowData: [],
        gridApi: null
      },
      cargoDocUsageSelectedDialog: {
        visible: false,
        callback: rows => {
          this.pm.usageSelectCallBackFunc(rows)
        }
      },
      amsLogViewTitleDialog: {
        visible: false,
        rowData: []
      },
      billAddressDialog: {
        visible: false
      },
      searchBillNoDialog: {
        visible: false,
        params: {}
      },
      curAms: null,
      isEFreight: false,
      isOther: false,
      isYitong: false,
      isLink: false,
      isTradetech: false,
      isChineseLanguage: false,
      seaPortList: [],
      lineType: '', // 区分是Name 还是 Address
      routeCountry: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor
          },
          defaultColDef: {
            menuTabs: [], // 去掉每列的菜单
            filter: false
          },
          onRowClicked: this.onCarrierGridRowClickedEvent
        },
        rowData: []
      },
      coloadInSelfFilingIndicator: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridSelectEditor,
            CargoAgGridCommonTextareaEditor,
            CargoAgGridCommonInputEditor
          },
          defaultColDef: {
            menuTabs: [], // 去掉每列的菜单
            filter: false
          },
          onRowClicked: this.onCarrierGridRowClickedEvent2
        },
        rowData: []
      },
      cargoInfomation: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          rowHeight: 32,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridSelectEditor,
            CargoAgGridCommonTextareaEditor,
            AgGridColumnEdit,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceMultipleSelectEditor
          },
          onRowClicked: this.onCarrierGridRowClickedEvent3,
          context: {
            componentParent: this
          }
        }
      },
      clickedRow: null,
      clickedRow2: null,
      clickedRow3: null,
      gridApi: null,
      gridApi2: null,
      gridApi3: null,
      showSellerBuyer: false, // 买方卖方是否展示
      calculatedTotals: {
        quantity: 0,
        weight: '0'
      },
      countryList: getCacheListByKey(TYPE_NAMES.basic_data_Country)
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && (!this.form.uuid || this.form.state < 2)
    },
    config() {
      return this.context.config
    },
    job() {
      return this.pm.job
    },
    user() {
      return this.context.user || {}
    },
    amsTitle() {
      return this.pm.getNoTitle(false, this.tabName)
    },
    amsTitleCn() {
      return this.pm.getNoTitle(true, this.tabName)
    },
    warningCount() {
      return this.isTradetech ? 40 : 70
    },
    shipCompanyInfos() {
      return this.localData.shipCompanyInfos.filter(c => c.carrierEori)
    },
    containerColumnDefs() {
      return [
        {
          headerName: '',
          colId: 'uuid',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.getEnsInfoAITitle('No'),
          field: '',
          colId: '',
          minWidth: 140,
          cellRenderer: function(params) {
            // params.rowIndex 是当前行的索引
            return params.rowIndex + 1 // 从 1 开始计数
          }
        },
        {
          headerName: this.getEnsInfoAITitle('Container No'),
          colId: 'containerNo',
          field: 'containerNo',
          width: 160,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellStyle: (params) => {
            return this.containerNbrStyleFunction(params)
          },
          onCellValueChanged: params => {
            this.validColumn('containerNo', params)
            this.onContainerNoCellChanged(params)
          }
        },
        {
          headerName: this.getEnsInfoAITitle('Container Size'),
          colId: 'eqSize',
          field: 'eqSize',
          width: 160,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: EQ_SIZES,
            tagName: 'name',
            tagValue: 'code'
          },
          onCellValueChanged: params => this.synEqCode(params)
        },
        {
          headerName: this.getEnsInfoAITitle('Container Type'),
          colId: 'eqType',
          field: 'eqType',
          width: 160,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_EQType,
              tagValue: 'code',
              tagName: 'code',
              filterable: true,
              filterTagNames: ['code'],
              clearable: false
            }
          },
          onCellValueChanged: params => this.synEqCode(params)
        },
        {
          headerName: this.getEnsInfoAITitle('Linked cargo'),
          colId: 'linkedCargoSerialNumber',
          field: 'linkedCargoSerialNumber',
          width: 120
        },
        {
          headerName: this.getEnsInfoAITitle('Container owner'),
          colId: 'containerOwnershipCode',
          field: 'containerOwnershipCode',
          cellEditor: 'CargoAgGridSelectEditor',
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: [...SystemConstants.EF_ENS_CONTAINER_OWNER_AI],
            tagName: this.isChineseLanguage ? 'chineseName' : 'englishName',
            tagValue: 'code'
          },
          valueFormatter: params => {
            return CommonState.getNameByCode(SystemConstants.EF_ENS_CONTAINER_OWNER_AI, params.value)
          }
        }
      ]
    },
    declaringCountrys() {
      return this.localData.ytCountry
    },
    isF14() {
      return this.form.declarationType === 'F14'
    },
    isF15() {
      return this.form.declarationType === 'F15'
    },
    isF16F17() {
      return this.form.declarationType === 'F16' || this.form.declarationType === 'F17'
    },
    isF17() {
      return this.form.declarationType === 'F17'
    },
    containerFinalRowData() {
      return this.container.rowData.filter(p => !p.deleted)
    },
    ams2ColumnDefs() {
      return [
        {
          headerName: this.getEnsInfoAITitle('ENS No'),
          colId: 'hblNbr2',
          field: 'hblNbr2',
          flex: 1,
          width: 260,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.validColumn('hblNbr2', params)
            this.onHblNbr2CellChange(params)
          }
        },
        {
          headerName: this.getEnsInfoAITitle('MRN No'),
          colId: 'ensMessageId',
          field: 'ensMessageId',
          flex: 1,
          width: 260
        },
        {
          headerName: this.getEnsInfoAITitle('Transmit Status'),
          colId: 'ENSSTATUS',
          field: 'ENSSTATUS',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            // 区分发送成功和发送失败的场景
            if (params.value === 1) {
              if (!params.data?.ensReceiptCode) {
                return this.pm.setStatusWithColor(2, this.isChineseLanguage)
              } else if (params.data?.ensReceiptCode === 'T') {
                return this.pm.setStatusWithColor(1, this.isChineseLanguage)
              } else if (params.data?.ensReceiptCode === 'F') {
                return this.pm.setStatusWithColor(0, this.isChineseLanguage)
              } else {
                return this.pm.setStatusWithColor(1, this.isChineseLanguage)
              }
            } else {
              return this.pm.setStatusWithColor(null, this.isChineseLanguage)
            }
          },
          tooltipValueGetter: (params) => {
            return this.pm.setStatus(params.value, true)
          }
        },
        {
          headerName: this.getEnsInfoAITitle('Customs Status'),
          colId: 'ensReceiptCode',
          field: 'ensReceiptCode',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            if (!params.value || params.value === 'F' || params.value === 'T') {
              return ''
            } else {
              return this.pm.setCustomsStatusWithColor(params.value, this.isChineseLanguage)
            }
          }
        },
        {
          headerName: this.getItemTitle('Send State Update Time'),
          colId: 'ensSendDate',
          field: 'ensSendDate',
          flex: 1,
          width: 260
        },
        {
          headerName: this.getItemTitle('Customs Status Update Time'),
          colId: 'ensReceiptDate',
          field: 'ensReceiptDate',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            // 海关回执应该排除掉ensReceiptCode为T或者F的场景
            if (params.data?.ensReceiptCode && (params.data?.ensReceiptCode === 'T' || params.data?.ensReceiptCode === 'F')) {
              return ''
            } else {
              return params.value
            }
          }
        }
      ]
    },
    language() {
      return this.$store.getters.language
    },
    columnDefs2() {
      return [
        {
          headerName: this.getEnsInfoAITitle('No'),
          sortable: false,
          width: 20,
          suppressMenu: true,
          valueGetter: params => {
            return params.node.rowIndex + 1
          }
        },
        {
          headerName: this.getEnsInfoAITitle('SupplementaryDeclarantEORI'),
          colId: 'eori',
          field: 'eori',
          width: 95,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.validColumn('eori', params)
          }
        },
        {
          headerName: this.getEnsInfoAITitle('SupplementaryDeclarantType'),
          suppressColumnsToolPanel: this.isTradetech,
          colId: 'blType',
          field: 'blType',
          width: 95,
          cellEditor: 'CargoAgGridSelectEditor',
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: [...SystemConstants.EF_ENS_BL_TYPE_AI],
            tagName: 'englishName',
            tagValue: 'code'
          },
          valueFormatter: params => {
            return CommonState.getNameByCode(SystemConstants.EF_ENS_BL_TYPE_AI, params.value)
          }
        }
      ]
    },
    receiptColumnDefs() {
      return [
        {
          headerName: this.amsTitle,
          field: 'ams',
          width: 200
        },
        {
          headerName: 'Receipt Status',
          field: 'receiptCode',
          width: 200,
          cellRenderer: params => {
            return params.value
          }
        },
        {
          headerName: 'Description',
          field: 'remark',
          width: 375
        },
        {
          headerName: 'Time',
          field: 'receiptDate',
          width: 200
        }
      ]
    },
    cargoInformationColumnDefs() {
      return [
        {
          headerName: '',
          colId: 'uuid',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.getEnsInfoAITitle('No'),
          field: '',
          colId: '',
          minWidth: 140,
          cellRenderer: function(params) {
            return params.data ? params.data.serialNo || 1 : 1
          }
        },
        {
          headerName: this.getEnsInfoAITitle('HS CODE'),
          colId: 'hsCode',
          field: 'hsCode',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.validColumn('hsCode', params)
            this.pm.synclinkedCargoSerialNumberByHsCode(params)
          }
        },
        {
          headerName: this.getEnsInfoAITitle('Linked Container'),
          colId: 'correlativeContainerNo',
          field: 'correlativeContainerNo',
          editable: this.isEdit,
          valueFormatter: (params) => {
            return this.multipleDataCellRenderer(params.data, 'correlativeContainerNo', ' | ')
          },
          cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = this.allContainerNo.map(item => ({
              code: item,
              value: item
            }))
            return {
              selectProps: {
                multiple: true,
                defaultMultipleValue: params.value,
                tagValue: 'code',
                tagName: 'value',
                staticOptions: staticOptions
              }
            }
          },
          onCellValueChanged: params => this.onCorrelativeContainerNoCellValueChanged(params)
        },
        {
          headerName: this.getEnsInfoAITitle('Quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 160,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.validColumn('quantity', params)
          },
          valueFormatter: params => {
            if (params.value) {
              if (params.value > 99999999) {
                return this.$numeral(99999999).format('0')
              } else if (params.value <= 0) {
                return 0
              } else {
                return this.$numeral(params.value).format('0')
              }
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.getEnsInfoAITitle('unit type'),
          headerTooltip: this.$t('SeaExport.Packing'),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          colId: 'packing',
          field: 'packing',
          width: 160,
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Packing,
              filterable: true,
              tagValue: 'code',
              customLabel: (item) => this.language === 'zh' ? `${item.chineseName}[${item.name}]` : `${item.name}[${item.chineseName}]`,
              showCustomLabelInOption: true
            }
          },
          valueFormatter: params => {
            return ColumnUtils.packingCodeLabelFun(params.value)
          }
        },
        {
          headerName: this.getEnsInfoAITitle('Gross weight'),
          headerTooltip: this.$t('SeaExport.GrossWeight'),
          colId: 'weight',
          field: 'weight',
          width: 260,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.validColumn('weight', params)
          },
          valueFormatter: params => {
            const data = this.formatWeightHandler(params.value)
            return data <= 0 ? '' : data
          }
        },
        {
          headerName: this.getEnsInfoAITitle('Marks'),
          colId: 'mark',
          field: 'mark',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false,
            filterChart: false
          },
          // 值变化事件
          onCellValueChanged: params => {
            this.validColumn('mark', params)
          }
        },
        {
          headerName: this.getEnsInfoAITitle('Description'),
          colId: 'cargoEnglishName',
          field: 'cargoEnglishName',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false,
            filterChart: false
          },
          // 值变化事件
          onCellValueChanged: params => {
            this.validColumn('cargoEnglishName', params)
          }
        },
        {
          headerName: this.getEnsInfoAITitle('UN CODE'),
          colId: 'undgCode',
          field: 'undgCode',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.validColumn('undgCode', params)
          }
        },
        {
          headerName: this.getEnsInfoAITitle('CUS No'),
          colId: 'cusCode',
          field: 'cusCode',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.validColumn('cusCode', params)
          }
        }
      ]
    },
    addressForm() {
      return this.form.afrAddress[0] || {}
    },
    // 计算装箱信息的箱号信息
    allContainerNo() {
      if (!this.container.rowData || !this.container.rowData.length) {
        return []
      }
      // 过滤箱号为空的数据，去除箱号前后的空格
      return this.container.rowData
        .filter(container => container.containerNo && !container.deleted && container.containerNo.trim() !== '')
        .map(container => container.containerNo.trim())
    }
  },
  watch: {
    'form.carrierEori': {
      handler(newVal, oldVal) {
        this.syncCheckMbl(newVal)
      }
    },
    'form.mbl': {
      handler(newVal, oldVal) {
        this.validateMBL(newVal)
      }
    },
    // 监听货物信息数组的变化
    'form.ensCargoInfo': {
      deep: true, // 启用深度监听
      handler(newVal, oldVal) {
        this.updateCargoTypeByEnsCargoInfo(newVal)
      }
    },
    'form.declarationType': {
      handler(newVal, oldVal) {
        if (this.isF16F17 || this.isF14) {
          this.addressForm.copyToSeller = false
          this.addressForm.copyToBuyer = false
        }
        if (this.isF17) {
          let consistent = false
          let thisData = null
          if (this.form.mbl) {
            for (const data of this.ams2.rowData) {
              if (this.form.mbl === data.hblNbr2) {
                consistent = true
              }
              if (this.form.hblNbr2 === data.hblNbr2) {
                thisData = data
              }
            }
            if (!consistent && thisData) {
              thisData.hblNbr2 = this.form.mbl
              this.form.hblNbr2 = this.form.mbl
              // 刷新表格显示
              this.ams2.gridApi.refreshCells({
                force: true,
                columns: ['hblNbr2']
              })
            }
          }
        }
      }
    },
    // 监听真实发货人信息变化
    'addressForm': {
      deep: true, // 启用深度监听
      handler(newVal, oldVal) {
        this.validAddressForm()
        this.copyToSellerBuyerHandler(newVal)
      }
    },
    'addressForm.copyToSeller': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.copyToSellerBuyerHandler()
        }
      }
    },
    'addressForm.copyToBuyer': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.copyToSellerBuyerHandler()
        }
      }
    },
    'form.loadingPortCode': {
      handler(newVal, oldVal) {
        this.addRouteCountry(newVal, 'loadingPortCode')
      }
    },
    'form.dischargingPortCode': {
      handler(newVal, oldVal) {
        this.addRouteCountry(newVal, 'dischargingPortCode')
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.visible = true
    this.isEFreight = this.config.get('ENSSupplierConfiguration') === 'eFreight'
    this.isYitong = this.config.get('ENSSupplierConfiguration') === 'yitong'
    this.isLink = this.config.get('ENSSupplierConfiguration') === 'link'
    this.isTradetech = this.config.get('ENSSupplierConfiguration') === 'tradetech'
    this.isOther = this.config.get('ENSSupplierConfiguration') === 'other'
    this.isChineseLanguage = this.$store.getters.language === 'zh'
    this.seaPortList = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
  },
  methods: {
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    /**
     * 添加装箱信息
     */
    addContainerUsageClickHandler() {
      // 创建新的装箱信息对象
      const baseContainer = new EDIContainer().fillDefaultValue().getData()
      baseContainer.deleted = false
      baseContainer.containerNo = ''
      baseContainer.sealNo = ''
      baseContainer.eqType = ''
      baseContainer.eqSize = ''
      baseContainer.quantity = 0
      baseContainer.weight = 0
      baseContainer.cubage = 0
      baseContainer.mark = ''
      baseContainer.cargoName = ''
      baseContainer.cargoDocUuid = this.form.uuid
      baseContainer.containerUsageUuid = null
      baseContainer.containerOwnershipCode = SystemConstants.EF_ENS_CONTAINER_OWNER_1_AI.code
      baseContainer.eqCode = ''
      this.container.rowData.push(baseContainer)
    },
    /**
     * 移除装箱信息
     */
    removeContainerUsageClickHandler() {
      const rows = this.container.gridApi.getSelectedRows()
      if (rows.length === 0) {
        return
      }
      for (const row of rows) {
        if (row.uuid) {
          row.deleted = true
        } else {
          const index = this.container.rowData.findIndex(p => p === row)
          if (index >= 0) {
            this.container.rowData.splice(index, 1)
          }
        }
        // 同时更细货物信息的关联箱号数据
        if (row.containerNo) {
          this.updateCargoCorrelativeContainerNo(row.containerNo, null)
        }
      }
      const tempRowData = this.container.rowData
      this.container.rowData = []
      this.$nextTick(() => {
        this.container.rowData = tempRowData
        if (this.form.docType === CargoDocConsts.AMS) {
          this.pm.refreshEdiGrid()
        }
      })
    },
    /**
     * 更新货物信息关联箱号
     * @param {string} oldContainerNo - 需要移除的箱号
     * @param newContainerNo - 更新的值，如果存在就说明是更新，不存在就是删除
     */
    updateCargoCorrelativeContainerNo(oldContainerNo, newContainerNo) {
      if (!this.form.ensCargoInfo?.length || !oldContainerNo) {
        return
      }

      this.form.ensCargoInfo.forEach(cargo => {
        if (cargo.correlativeContainerNo) {
          // 将逗号分隔的字符串转为数组
          const containerNos = cargo.correlativeContainerNo.split(',').filter(Boolean)

          // 移除指定箱号
          const index = containerNos.indexOf(oldContainerNo)
          if (index !== -1) {
            if (newContainerNo) {
              // 更新为新箱号
              containerNos[index] = newContainerNo
            } else {
              containerNos.splice(index, 1)
            }
            // 更新回逗号分隔的字符串
            cargo.correlativeContainerNo = containerNos.join(',')
          }
        }
      })

      // 如果有数据更新，刷新整个货物信息表格
      this.gridApi3?.refreshCells({
        force: true,
        columns: ['correlativeContainerNo']
      })
    },
    commandHandle(command) {
      switch (command) {
        case 'Code Searching':
          this.billAddressDialog.visible = true
          break
        case 'Copy Last Time':
          this.pm.onCopy1()
          break
        case 'Copy By File NO':
          Object.assign(this.searchBillNoDialog.params, {
            docType: 'AMS',
            selectType: 'single',
            job: this.job
          })
          this.searchBillNoDialog.visible = true
          break
      }
    },
    hblNbr2Change() {
      const { gridApi } = this.ams2
      gridApi.refreshCells()
      this.$nextTick(() => {
        if (this.curAms) {
          const { rowsToDisplay } = gridApi.getModel()
          const selectedNode = rowsToDisplay.find(node => node.data.hblNbr2 === this.curAms.hblNbr2)
          selectedNode.setSelected(true)
        }
      })
    },
    mblChange() {
      if (this.isYitong && this.isF17) {
        this.form.hblNbr2 = this.form.mbl
      }
    },
    portChange(p, portCodeField, portNameField) {
      const form = this.form
      form[portCodeField] = p.value
      form[portNameField] = p.englishName
    },
    /**
     * 发货人选择
     */
    async shipperChange(data) {
      const form = this.addressForm
      form.shipperId = data.value
      if (form.shipperId) {
        // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.shipperLine1 = manifestAddress.addressLine1
          // form.shipperLine2 = manifestAddress.addressLine2
          form.shipperLine3 = manifestAddress.addressLine2
          form.shipperLine4 = manifestAddress.addressLine3
          //
          let shipperLine5 = manifestAddress.addressLine4 || ''
          if (shipperLine5) shipperLine5 += '\n'
          if (manifestAddress.addressLine5) shipperLine5 += manifestAddress.addressLine5
          if (shipperLine5) shipperLine5 += '\n'
          if (manifestAddress.addressLine6) shipperLine5 += manifestAddress.addressLine6
          if (shipperLine5) shipperLine5 += '\n'
          if (manifestAddress.addressLine7) shipperLine5 += manifestAddress.addressLine7
          form.shipperLine5 = shipperLine5
        } else {
          form.shipperLine1 = ''
          form.shipperLine2 = ''
          form.shipperLine3 = ''
          form.shipperLine4 = ''
          form.shipperLine5 = ''
          form.shipperLine6 = ''
          form.shipperLine7 = ''
        }
      }
    },
    /**
     * 收货人选择
     */
    async consigneeChange(data) {
      const form = this.addressForm
      form.consigneeId = data.value
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      if (form.consigneeId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.consigneeLine1 = manifestAddress.addressLine1
          // form.consigneeLine2 = manifestAddress.addressLine2
          form.consigneeLine3 = manifestAddress.addressLine2
          form.consigneeLine4 = manifestAddress.addressLine3
          //
          let consigneeLine5 = manifestAddress.addressLine4 || ''
          if (consigneeLine5) consigneeLine5 += '\n'
          if (manifestAddress.addressLine5) consigneeLine5 += manifestAddress.addressLine5
          if (consigneeLine5) consigneeLine5 += '\n'
          if (manifestAddress.addressLine6) consigneeLine5 += manifestAddress.addressLine6
          if (consigneeLine5) consigneeLine5 += '\n'
          if (manifestAddress.addressLine7) consigneeLine5 += manifestAddress.addressLine7
          form.consigneeLine5 = consigneeLine5
        } else {
          form.consigneeLine1 = ''
          form.consigneeLine2 = ''
          form.consigneeLine3 = ''
          form.consigneeLine4 = ''
          form.consigneeLine5 = ''
          form.consigneeLine6 = ''
          form.consigneeLine7 = ''
        }
      }
    },
    /**
     * 卖方选择
     */
    async sellerChange(data) {
      const form = this.addressForm
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      if (data.value) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.sellerName = manifestAddress.addressLine1
          form.sellerAddress1 = manifestAddress.addressLine3
          form.sellerAddress2 = manifestAddress.addressLine4
        } else {
          form.sellerName = ''
          form.sellerAddress1 = ''
          form.sellerAddress2 = ''
        }
      }
    },
    /**
     * 买方选择
     */
    async buyerChange(data) {
      const form = this.addressForm
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      if (data.value) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.buyerName = manifestAddress.addressLine1
          form.buyerAddress1 = manifestAddress.addressLine3
          form.buyerAddress2 = manifestAddress.addressLine4
        } else {
          form.buyerName = ''
          form.buyerAddress1 = ''
          form.buyerName = ''
        }
      }
    },
    showSenderAndReceiverDialog(type, count) {
      const value = this.mergeSenderAndReceiverLineForAmsAndManifest(type, count)
      switch (type) {
        case 'shipper':
          this.advanceTextDialog.title = this.$t('SeaExport.Shipper')
          this.advanceTextDialog.warningCount = this.isTradetech ? 40 : 70
          break
        case 'consignee':
          this.advanceTextDialog.title = this.$t('SeaExport.Consignee')
          this.advanceTextDialog.warningCount = this.isTradetech ? 40 : 70
          break
        case 'notify':
          this.advanceTextDialog.title = this.$t('SeaExport.Notifier')
          this.advanceTextDialog.warningCount = this.isTradetech ? 40 : 70
          break
        case 'seller':
          this.advanceTextDialog.title = this.$t('SeaExport.Seller')
          this.advanceTextDialog.warningCount = 70
          break
        case 'buyer':
          this.advanceTextDialog.title = this.$t('SeaExport.Buyer')
          this.advanceTextDialog.warningCount = 70
          break
        case 'shipperEmail':
        case 'consigneeEmail':
        case 'notifyEmail':
          this.advanceTextDialog.title = this.$t('SeaExport.Email')
          if (this.isYitong) {
            this.advanceTextDialog.warningCount = 512
          } else if (this.isEFreight) {
            this.advanceTextDialog.warningCount = 100
          } else if (this.isTradetech) {
            this.advanceTextDialog.warningCount = 23
          }
          break
        case 'shipperTel':
        case 'consigneeTel':
        case 'notifyTel':
          this.advanceTextDialog.title = this.$t('SeaExport.Tel')
          if (this.isYitong) {
            this.advanceTextDialog.warningCount = 512
          } else if (this.isEFreight) {
            this.advanceTextDialog.warningCount = 24
          } else if (this.isTradetech) {
            this.advanceTextDialog.warningCount = 23
          }
          break
      }
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = () => this.splitSenderAndReceiverLineForAmsAndManifest(type, count, this.advanceTextDialog.value)
      this.advanceTextDialog.visible = true
    },
    mergeSenderAndReceiverLineForAmsAndManifest(type, count) {
      const addressForm = this.form.afrAddress[0]
      if (type === 'shipper' || type === 'consignee' || type === 'notify') {
        let result = ''
        for (let i = 1; i < count; ++i) {
          let no = i
          if (i !== 1) {
            no = (i + 1)
          }
          result += addressForm[`${type}Line${no}`] || ''
          result += '\n'
        }
        result += (addressForm[`${type}Line${count + 1}`] || '')
        return result.trimEnd()
      } else if (type === 'seller' || type === 'buyer') {
        const result2 = addressForm[`${type}Name`] + '\n' + addressForm[`${type}Address1`]
        return result2.trimEnd()
      } else {
        return addressForm[type].trimEnd()
      }
    },
    splitSenderAndReceiverLineForAmsAndManifest(type, count, val) {
      const addressForm = this.form.afrAddress[0]
      if (type === 'shipper' || type === 'consignee' || type === 'notify') {
        let fromIndex = 0
        let i = 1
        let no = 1
        for (; i < count; ++i) {
          no = (i !== 1) ? (i + 1) : i
          const index = val.indexOf('\n', fromIndex)
          if (index === -1) {
            addressForm[`${type}Line${no}`] = ''
            continue
          }
          addressForm[`${type}Line${no}`] = val.substring(fromIndex, index)
          fromIndex = index + 1
        }
        addressForm[`${type}Line${no + 1}`] = val.substring(fromIndex)
      } else if (type === 'seller' || type === 'buyer') {
        if (val) {
          const datas = val.split('\n')
          addressForm[`${type}Name`] = datas[0]
          if (datas.length > 1) {
            addressForm[`${type}Address1`] = datas[1]
          } else {
            addressForm[`${type}Address1`] = ''
          }
        } else {
          addressForm[`${type}Name`] = ''
          addressForm[`${type}Address1`] = ''
        }
      } else {
        addressForm[type] = val
      }
    },
    isDifferent(eFreight, yitong, tradetech, link) {
      if (eFreight && (this.isEFreight || this.isOther)) {
        return 'blue-text'
      }
      if (yitong && this.isYitong) {
        return 'blue-text'
      }
      if (tradetech && this.isTradetech) {
        return 'blue-text'
      }
      if (link && this.isLink) {
        return 'blue-text'
      }
      return ''
    },
    isShow(eFreight, yitong, tradetech) {
      if (eFreight && (this.isEFreight || this.isOther)) {
        return true
      }
      if (yitong && this.isYitong) {
        return true
      }
      if (tradetech && this.isTradetech) {
        return true
      }
      return false
    },
    cityMaxLength(value) {
      if (!value) return ''
      if (this.isYitong) {
        return value.length > 35 ? 'warning' : ''
      } else if (this.isEFreight) {
        return value.length > 25 ? 'warning' : ''
      } else if (this.isTradetech) {
        return value.length > 26 ? 'warning' : ''
      } else {
        return ''
      }
    },
    stateMaxLength(value) {
      if (!value) return ''
      if (this.isEFreight || this.isTradetech) {
        return value.length > 2 ? 'warning' : ''
      } else {
        return ''
      }
    },
    zipMaxLength(value) {
      if (!value) return ''
      if (this.isYitong) {
        return value.length > 17 ? 'warning' : ''
      } else if (this.isEFreight) {
        return value.length > 10 ? 'warning' : ''
      } else if (this.isTradetech) {
        return value.length > 10 ? 'warning' : ''
      } else {
        return ''
      }
    },
    emailMaxLength(value) {
      if (!value) return ''
      if (this.isYitong) {
        return value.length > 512 ? 'warning' : ''
      } else if (this.isEFreight) {
        return value.length > 100 ? 'warning' : ''
      } else if (this.isTradetech) {
        return value.length > 23 ? 'warning' : ''
      } else {
        return ''
      }
    },
    telMaxLength(value) {
      if (!value) return ''
      if (this.isYitong) {
        return value.length > 512 ? 'warning' : ''
      } else if (this.isEFreight) {
        return value.length > 24 ? 'warning' : ''
      } else if (this.isTradetech) {
        return value.length > 23 ? 'warning' : ''
      } else {
        return ''
      }
    },
    setCellColor(data, field) {
      const importDifferentField = this.localData.importDifferentField
      if (!importDifferentField ||
        !importDifferentField.container ||
        !importDifferentField.container[data.containerNo]) {
        return {}
      }
      if (importDifferentField.container[data.containerNo].hasOwnProperty(field)) {
        return { 'color': 'red' }
      }
      return {}
    },
    expandSellerBuyer() {
      this.showSellerBuyer = !this.showSellerBuyer
    },
    openCheckTip(data) {
      this.checkDialog.visible = true
      // 去重
      const uniqueMap = new Map()
      if (data) {
        data.forEach(item => {
          let key = item.field + '|' + item.errorDescription
          if (item.type) {
            key = item.type + item.field + '|' + item.errorDescription
          }
          if (!uniqueMap.has(key)) {
            if (item.type) {
              item.field = this.getEnsInfoAITitle(item.type) + ' ' + this.getEnsInfoAITitle(item.field)
            } else {
              item.field = this.getEnsInfoAITitle(item.field)
            }
            uniqueMap.set(key, item)
          }
        })
      }
      this.checkDialog.rowData = Array.from(uniqueMap.values())
    },
    getItemTitle(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.afrLabelFunc(targetCode)
      }
      return targetCode
    },
    getEnsInfoAITitle(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.ensAiLabelFunc(targetCode)
      }
      return targetCode
    },
    onCarrierGridRowClickedEvent(e) {
      this.clickedRow = e.data
    },
    onCarrierGridRowClickedEvent2(e) {
      this.clickedRow2 = e.data
    },
    onCarrierGridRowClickedEvent3(e) {
      this.clickedRow3 = e.data
    },
    addRouteCountry(newVal, type) {
      // 第一个国家为起运港的国家，第二个为目的港的国家。无需用户再自己填写
      if (!this.form.routeCountryList || this.form.routeCountryList.length === 0) {
        this.form.routeCountryList = []
      }
      if (newVal) {
        const port = this.seaPortList.find(p => p.code === newVal)
        // 与旧的数据保持一致
        const portItem = { country: port.countryCode }
        if (port && port.countryCode) {
          if (type === 'loadingPortCode') {
            this.form.routeCountryList[0] = portItem
          } else if (type === 'dischargingPortCode') {
            this.form.routeCountryList[1] = portItem
          }
        }
      } else {
        if (type === 'loadingPortCode') {
          this.form.routeCountryList[0] = { country: '' }
        } else if (type === 'dischargingPortCode') {
          this.form.routeCountryList[1] = { country: '' }
        }
      }
    },
    addRouteCountry2() {
      if (!this.form.ensDeclarationData) {
        this.form.ensDeclarationData = []
      } else if ((this.isYitong || this.isTradetech) && this.form.ensDeclarationData.length === 1) {
        this.$message.warning(this.$t('SeaExport.NeedOne'))
        return
      }
      this.form.ensDeclarationData.push({
        supplementaryDeclarant: '', eori: '', blType: SystemConstants.EF_ENS_BL_TYPE_2_AI.code
      })
      this.gridApi2.setRowData(this.form.ensDeclarationData)
    },
    addCargoInfo() {
      // 定义新的
      const newCargoInfo = {
        weight: '',
        quantity: '',
        deleted: false,
        mark: '',
        correlativeContainerNo: '',
        newUuid: UIDUtil.createUID(),
        dateCreated: new Date().toISOString()
      }

      if (!this.form.ensCargoInfo || !this.form.ensCargoInfo?.length) {
        // 如果是第一条品名信息，则序号自动生横撑，唛头默认写入N/M，其余字段置空
        this.form.ensCargoInfo = []
        newCargoInfo.mark = 'N/M'
      } else if (this.form.ensCargoInfo.length > 0) {
        // 如果已经有品名记录，点新增默认复制上一条记录的内容（全部字段）
        const lastRecord = this.form.ensCargoInfo
          .slice()
          .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))[0]

        // 复制上一条记录的相关字段
        Object.assign(newCargoInfo, {
          weight: lastRecord.weight,
          quantity: lastRecord.quantity,
          hsCode: lastRecord.hsCode,
          mark: lastRecord.mark,
          packing: lastRecord.packing,
          cargoEnglishName: lastRecord.cargoEnglishName,
          undgCode: lastRecord.undgCode,
          cusCode: lastRecord.cusCode,
          correlativeContainerNo: lastRecord.correlativeContainerNo
        })
      }
      newCargoInfo.serialNo = this.form.ensCargoInfo.length + 1
      this.form.ensCargoInfo.push(newCargoInfo)
      this.gridApi3.setRowData(this.form.ensCargoInfo)
      // 刷新箱子关联品名
      this.pm.synclinkedCargoSerialNumber()
      // 刷新数量重量合计
      this.updateTotals()
    },
    deleteRouteCountry2() {
      const index = this.form.ensDeclarationData.indexOf(this.clickedRow2)
      if (index !== -1) {
        this.form.ensDeclarationData.splice(index, 1)
        if (this.clickedRow2.uuid) {
          if (!this.form.delEnsDeclarationUuids) {
            this.form.delEnsDeclarationUuids = []
          }
          this.form.delEnsDeclarationUuids.push(this.clickedRow2.uuid)
        }
      }
      this.gridApi2.setRowData(this.form.ensDeclarationData)
    },
    deleteCargoInfo() {
      const rows = this.gridApi3.getSelectedRows()
      if (rows.length === 0) {
        return
      }
      for (const row of rows) {
        const index = this.form.ensCargoInfo.findIndex(p => p.uuid === row.uuid)
        if (index >= 0) {
          this.form.ensCargoInfo.splice(index, 1)
        } else {
          const index = this.form.ensCargoInfo.findIndex(p => p.newUuid === row.newUuid)
          if (index >= 0) {
            this.form.ensCargoInfo.splice(index, 1)
          }
        }
        if (row.uuid) {
          if (!this.form.delEnsCargoInfoUuids) {
            this.form.delEnsCargoInfoUuids = []
          }
          this.form.delEnsCargoInfoUuids.push(row.uuid)
        }
      }
      if (this.form.ensCargoInfo.length > 0) {
        this.form.ensCargoInfo.forEach((item, idx) => {
          item.serialNo = idx + 1
        })
      }
      this.gridApi3.setRowData(this.form.ensCargoInfo)

      // 刷新品名
      this.pm.synclinkedCargoSerialNumber()
      this.updateTotals()
    },
    deleteAllCargoInfo() {
      if (this.form.ensCargoInfo && this.form.ensCargoInfo.length > 0) {
        for (const row of this.form.ensCargoInfo) {
          if (row.uuid) {
            if (!this.form.delEnsCargoInfoUuids) {
              this.form.delEnsCargoInfoUuids = []
            }
            this.form.delEnsCargoInfoUuids.push(row.uuid)
          }
        }
      }
    },
    refreshList() {
      if (this.form.routeCountryList && this.gridApi) {
        setTimeout(() => {
          this.gridApi.setRowData(this.form.routeCountryList)
        }, 100)
      }
      if (this.form.ensDeclarationData && this.gridApi2) {
        setTimeout(() => {
          this.gridApi2.setRowData(this.form.ensDeclarationData)
        }, 100)
      }
      if (this.form.ensCargoInfo && this.gridApi3) {
        setTimeout(() => {
          this.gridApi3.setRowData(this.form.ensCargoInfo)
        }, 100)
      }
      this.updateTotals()
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.addressForm['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.addressForm['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.addressForm['notifyCode'] = data.notifyCode || ''
      }
    },
    splitShipperLine(data) {
      this.splitSenderAndReceiverLine('shipper', 5, data.shipperInfo)
      this.splitAddress('shipper', data)
    },
    splitSenderAndReceiverLine(type, count, val) {
      const addressForm = this.addressForm
      let fromIndex = 0
      let i = 1
      let no = 1
      for (; i < count; ++i) {
        no = (i !== 1) ? (i + 1) : i
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          addressForm[`${type}Line${no}`] = ''
          continue
        }
        addressForm[`${type}Line${no}`] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      addressForm[`${type}Line${no}`] = val.substring(fromIndex)
    },
    splitConsigneeLine(data) {
      this.splitSenderAndReceiverLine('consignee', 5, data.shipperInfo)
      this.splitAddress('consignee', data)
    },
    splitNotifyLine(data) {
      this.splitSenderAndReceiverLine('notify', 5, data.shipperInfo)
      this.splitAddress('notify', data)
    },

    splitAddress(type, data) {
      const addressForm = this.addressForm
      addressForm[type + 'Country'] = data[type + 'CountryCode'] || ''
      addressForm[type + 'City'] = data[type + 'CityName'] || ''
      addressForm[type + 'Postalcode'] = data[type + 'ZipCode'] || ''
      addressForm[type + 'Province'] = data[type + 'ProvinceCode'] || ''
      addressForm[type + 'Eori'] = data[type + 'Eori'] || ''
      addressForm[type + 'StreetNo'] = data[type + 'StreetNo'] || ''
      if (data[type + 'ContactsType'] === 0) {
        addressForm[type + 'Tel'] = data[type + 'Contacts'] || ''
      } else if (data[type + 'ContactsType'] === 1) {
        addressForm[type + 'Email'] = data[type + 'Contacts'] || ''
      }
    },
    /**
     * 多值字段显示转换函数
     * @param {Object} data - 显示列的参数对象
     * @param {string} fieldName - 需要显示的字段名
     * @param {string} symbol - 分隔符
     * @returns {string} 转换后的显示字符串
     */
    multipleDataCellRenderer(data, fieldName, symbol) {
      // 参数校验
      if (!data || !fieldName) {
        return ''
      }

      const fieldValue = data[fieldName]

      // 字段值校验
      if (!fieldValue) {
        return ''
      }

      try {
        // 如果不是字符串类型，先转换为字符串
        const strValue = String(fieldValue)

        // 分割并过滤空值
        return strValue
          .split(',')
          .filter(Boolean)
          .map(item => item.trim())
          .filter(item => item !== '')
          .join(symbol || ',')
      } catch (error) {
        console.error('multipleDataRellRenderer error:', error)
        return String(fieldValue)
      }
    },
    onCorrelativeContainerNoCellValueChanged(params) {
      const curCargoInfo = params.data
      const newContainerNos = params.newValue
      const oldContainerNos = (params.oldValue || [])

      // 更新当前货物的关联箱号
      curCargoInfo.correlativeContainerNo = newContainerNos.join(',')

      if (newContainerNos && newContainerNos.length && !curCargoInfo.hsCode) {
        // 判断一种情况 因为下拉选项如果选完值关闭下拉框还会调用onCorrelativeContainerNoCellValueChanged方法（原因是curCargoInfo.correlativeContainerNo = newContainerNos.join(',')赋值导致的）所以
        // 如果newValue: Array [ "AAAU0000000", "BBBU0000000" ] oldValue: "AAAU0000000,BBBU0000000" 一致就直接返回 避免再次触发提示
        if (oldContainerNos === curCargoInfo.correlativeContainerNo) {
          return
        }
        this.$message.warning(this.$t('SeaExport.HscodeCannotBeEmpty'))
        return
      }

      // 更新箱子的关联状态
      if (this.container?.rowData) {
        // 找出需要更新的箱子
        const containersToUpdate = this.container.rowData.filter(container =>
          newContainerNos.includes(container.containerNo) || oldContainerNos.includes(container.containerNo)
        )

        // 更新箱子的关联状态
        containersToUpdate.forEach(container => {
          // 找出所有关联了该箱号的货物信息的HSCODE
          const linkedHsCodes = this.form.ensCargoInfo
            .map((cargo) => {
              const containerNos = (String(cargo.correlativeContainerNo) || '').split(',').filter(Boolean)
              return containerNos.includes(container.containerNo) ? cargo.hsCode : null
            })
            .filter(hsCode => hsCode !== null)

          // 赋值
          container.linkedCargoInformationNo = linkedHsCodes.join(';')
          // 如果需要保存到数据库，这里添加相关字段
          container.isModified = true // 标记已修改
        })

        // 同步刷新箱子的序号显示列
        this.pm.synclinkedCargoSerialNumber()
      }
    },
    onHblNbr2CellChange(params) {
      // 检查分单号是否为空
      if (!params.newValue || params.newValue.trim() === '') {
        this.$message.warning(this.$t('Message.ENSHblNbr2CannotBeNull'))
        params.data.hblNbr2 = params.oldValue
        this.ams2.gridApi.refreshCells({ force: true })
        return
      }

      // 检查分单号是否重复
      const isDuplicate = this.ams2.rowData.some(doc =>
        doc !== params.data && doc.hblNbr2 === params.newValue
      )
      if (isDuplicate) {
        this.$message.warning(this.$t('Message.HAWBCannotBeRepeated'))
        params.data.hblNbr2 = params.oldValue
        this.ams2.gridApi.refreshCells({ force: true })
        return
      }

      // 更新对应的 cargoDoc
      const cargoDoc = this.pm.cargoDocs.find(doc => doc.hblNbr2 === params.oldValue)
      if (cargoDoc) {
        cargoDoc.hblNbr2 = params.newValue
        // 如果是当前编辑的表单，同步更新 form
        if (this.pm.form && this.pm.form.uuid === cargoDoc.uuid) {
          this.pm.form.hblNbr2 = params.newValue
        }
      }

      // 更新表格数据
      const rowIndex = this.ams2.rowData.findIndex(row => row.hblNbr2 === params.oldValue)
      if (rowIndex !== -1) {
        this.ams2.rowData[rowIndex].hblNbr2 = params.newValue
        // 强制更新数组以触发视图更新
        this.ams2.rowData = [...this.ams2.rowData]
      }

      // 刷新表格显示
      this.ams2.gridApi.refreshCells({
        force: true,
        columns: ['hblNbr2']
      })
    },
    aiRecognitionHandler(multimodal = true, callBack = null, promptKey = '') {
      this.aiRecognitionDialog.multimodal = multimodal
      this.aiRecognitionDialog.jobUuid = this.job.uuid
      this.aiRecognitionDialog.docUuid = this.form.uuid
      this.aiRecognitionDialog.hblNbr2 = this.form.hblNbr2
      this.aiRecognitionDialog.source = multimodal ? SystemConstants.INTELLIGENT_DOCUMENT_SOURCE_15.code : 0
      this.aiRecognitionDialog.pageSource = 'customsInfo'
      this.aiRecognitionDialog.iChannel = SystemConstants.SENDING_6.code
      this.aiRecognitionDialog.callBack = callBack
      this.aiRecognitionDialog.promptKey = promptKey
      this.aiRecognitionDialog.visible = true
    },
    navigateToLink(code) {
      if (code === 'Query HS Code') {
        window.open('https://www.wcotradetools.org/en/harmonized-system', '_blank')
      } else if (code === 'Query CUS No') {
        window.open('https://ec.europa.eu/taxation_customs/dds2/ecics/chemicalsubstance_consultation.jsp?Lang=en', '_blank')
      }
    },
    // AI识别后处理箱子和货物信息
    aiRecognitionPostHandlerByCargo(jsonStr) {
      try {
        // 解析JSON字符串
        const result = JSON.parse(jsonStr)

        // 验证数据格式
        if (!Array.isArray(result) || result.length === 0 || !result[0].text || !result[0].text.data) {
          return
        }

        const cargoInfoResult = result[0].text.data.cargoInfo

        // 验证货物信息是否有效
        if (!Array.isArray(cargoInfoResult) || cargoInfoResult.length === 0) {
          return
        }
        // 清洗数据 过滤筛选项匹配不到的内容
        // 拆分数据 将数据拆为箱子和货物
        const containerList = []
        const cargoInfoList = []
        this.pm.convertValidCagoInfoHandler(cargoInfoResult, containerList, cargoInfoList)

        // 箱子处理更新的数据
        this.pm.aiRecognitionPostUpdateHandler(this.container.rowData, containerList, 'containerNo')
        // 货物处理更新的数据
        this.pm.aiRecognitionPostUpdateHandler(this.form.ensCargoInfo, cargoInfoList, 'hsCode')

        // 箱子和货物的联动问题
        // 新增货物、 直接新增到ensCargoInfo即可
        // 新增货物、 containerNo是旧的  因为旧的containerNo可能被其他货物选择，导致 correlativeContainerNo 有问题 需要重新赋值
        // 新增箱子、 直接新增到container即可
        // 新增箱子、 hsCode是旧的  因为旧的hsCode可能选择了其他的箱子，导致对应的箱子的linkedCargoInformationNo有问题 需要更新
        // 更新货物、 更新箱子
        // 根据货物的 correlativeContainerNo 重新处理箱子的 linkedCargoInformationNo 属性
        this.pm.aiRecognitionPostUpdateCargoInfoHandler(this.form.ensCargoInfo, this.container.rowData)

        // 更新箱子和货物的列表
        this.aiRecognitionPostRefreshListHandler()
      } catch (error) {
        console.log('error ===>', error)
      }
    },
    processAiRecognitionData(data) {
      const parsedData = typeof data === 'string' ? JSON.parse(data) : data
      if (!Array.isArray(parsedData) || !parsedData[0]?.text?.data) {
        return
      }

      return parsedData[0].text.data
    },
    processAiRecognition(jsonStr, type) {
      const data = this.processAiRecognitionData(jsonStr)
      if (!data) {
        return
      }
      // 处理格式化
      const fields = ['name', 'address1', 'address1', 'postalcode', 'city', 'streetno', 'country', 'tel', 'eori']
      for (const field of fields) {
        this.pm.validAndCounvertFieldByAddress(data, field)
      }

      if (data?.name) {
        if (type === 'shipper' || type === 'consignee') {
          this.addressForm[type + 'Line1'] = data.name
        } else {
          this.addressForm[type + 'Name'] = data.name
        }
      }
      if (data?.address1) {
        if (type === 'shipper' || type === 'consignee') {
          this.addressForm[type + 'Line3'] = data.address1
        } else {
          this.addressForm[type + 'Address1'] = data.address1
        }
      }
      if (data?.address2) {
        if (type === 'shipper' || type === 'consignee') {
          this.addressForm[type + 'Line4'] = data.address2
        } else {
          this.addressForm[type + 'Address2'] = data.address2
        }
      }
      if (data?.postalcode) {
        this.addressForm[type + 'Postalcode'] = data.postalcode
      }
      if (data?.city) {
        this.addressForm[type + 'City'] = data.city
      }
      if (data?.streetNo) {
        this.addressForm[type + 'StreetNo'] = data.streetNo
        // 处理是否勾选门牌号字段
        if (type === 'shipper') {
          this.form.noHouseNumberByShipper = this.addressForm.shipperStreetNo === 'N/A'
        } else if (type === 'consignee') {
          this.form.noHouseNumberByConsignee = this.addressForm.consigneeStreetNo === 'N/A'
        } else if (type === 'seller') {
          this.form.noHouseNumberBySeller = this.addressForm.sellerStreetNo === 'N/A'
        } else if (type === 'buyer') {
          this.form.noHouseNumberByBuyer = this.addressForm.buyerStreetNo === 'N/A'
        }
      }
      if (data?.country) {
        // 国家需要识别出对应的code赋值
        const country = getObjectByCacheMatchFiled(basicCacheKeys.basic_data_Country, ['code', 'name', 'chineseName'], data.country)
        if (country) {
          this.addressForm[type + 'Country'] = country.code
        }
      }
      if (data?.tel) {
        this.addressForm[type + 'Tel'] = data.tel
      }
      if (data?.eori) {
        this.addressForm[type + 'Eori'] = data.eori
      }
    },
    aiRecognitionPostHandlerByShipper(jsonStr) {
      this.processAiRecognition(jsonStr, 'shipper')
    },
    aiRecognitionPostHandlerByConsignee(jsonStr) {
      this.processAiRecognition(jsonStr, 'consignee')
    },
    aiRecognitionPostHandlerBySeller(jsonStr) {
      this.processAiRecognition(jsonStr, 'seller')
    },
    aiRecognitionPostHandlerByBuyer(jsonStr) {
      this.processAiRecognition(jsonStr, 'buyer')
    },
    synEqCode(param) {
      if (param.data && param.data?.eqSize && param.data?.eqType) {
        const eqCode = SystemConstants.EF_ENS_CONTAINER_MAP.get(param.data.eqSize + param.data.eqType)
        if (eqCode) {
          param.data.eqCode = eqCode
        } else {
          this.$message.error(this.$t('SeaExport.EqCodeMatchError'))
        }
      }
    },
    linkOperationRequirement() {
      window.open('https://n72qv2rrvp.feishu.cn/docx/XhE2dbVgBohcELxtQHlcaw2Nnjd?from=from_copylink', '_blank')
    },
    /**
     * 装箱信息-关联货物序号渲染
     * @param {Object} data - 当前箱子行数据
     * @returns {string} 关联的货物序号，以 | 分隔
     */
    onLinkCargoGoodsCellRenderer(data) {
      if (!data?.containerNo || !this.form.ensCargoInfo?.length) {
        return ''
      }
      if (data?.linkedCargoSerialNumber) {
        return data?.linkedCargoSerialNumber
      } else {
        // 找出所有关联了该箱号的货物信息的序号
        const linkedIndexes = this.form.ensCargoInfo
          .map((cargo, index) => {
            const containerNos = (String(cargo.correlativeContainerNo) || '').split(',').filter(Boolean)
            return containerNos.includes(data.containerNo) ? (index + 1) : null
          })
          .filter(index => index !== null)

        // 返回以|分隔的序号字符串
        return linkedIndexes.join(' | ')
      }
    },
    containerNbrStyleFunction(params) {
      const usage = params.data
      if (usage && !ContainerNoHelper.checkContainerNo(params.value)) {
        return { color: '#F56C6C' }
      }
      if (usage.uuid && DataPushCompareUtils.comparePushData(this.$t('SeaExport.ContainerNo'), params.value, usage.uuid)) {
        return { color: '#1F75D5' }
      }
      return { color: '' }
    },
    /**
     * 装箱信息-箱号变更后置处理
     */
    onContainerNoCellChanged(params) {
      const { newValue, oldValue, data } = params

      if (!newValue || newValue.trim() === '') {
        this.$message.warning(this.$t('SeaExport.CaseNumberCannotBeEmpty'))
        return
      }

      // 校验箱号是否重复
      const containerNos = this.container.rowData.map(item => item.containerNo)
      const duplicateCount = containerNos.filter(no => no === newValue).length

      if (duplicateCount > 1) {
        this.$message.warning(StrUtils.substitute(this.$t('Warehouse.duplicateContainerNo'), newValue))
        return
      }

      // 更新货物信息中关联的箱号
      this.updateCargoCorrelativeContainerNo(oldValue, newValue)
    },
    copyToSellerBuyerHandler() {
      if (this.addressForm.copyToSeller && this.isF15) {
        for (const oraginFieldName of ColumnUtils.shipperToSellerMap.keys()) {
          const targetFieldName = ColumnUtils.shipperToSellerMap.get(oraginFieldName)
          this.addressForm[targetFieldName] = this.addressForm[oraginFieldName]
          this.form.noHouseNumberBySeller = this.form.noHouseNumberByShipper
        }
      }
      if (this.addressForm.copyToBuyer && this.isF15) {
        for (const oraginFieldName of ColumnUtils.consigneeToBuyerMap.keys()) {
          const targetFieldName = ColumnUtils.consigneeToBuyerMap.get(oraginFieldName)
          this.addressForm[targetFieldName] = this.addressForm[oraginFieldName]
          this.form.noHouseNumberByBuyer = this.form.noHouseNumberByConsignee
        }
      }
      // 如果收发货人买家卖家的门牌号值为N/A就将勾选对应的没有门牌号字段
      if (this.addressForm.shipperStreetNo && this.addressForm.shipperStreetNo === 'N/A') {
        this.form.noHouseNumberByShipper = true
      }
      if (this.addressForm.consigneeStreetNo && this.addressForm.consigneeStreetNo === 'N/A') {
        this.form.noHouseNumberByConsignee = true
      }
      if (this.addressForm.sellerStreetNo && this.addressForm.sellerStreetNo === 'N/A') {
        this.form.noHouseNumberBySeller = true
      }
      if (this.addressForm.buyerStreetNo && this.addressForm.buyerStreetNo === 'N/A') {
        this.form.noHouseNumberByBuyer = true
      }
    },
    updateStreetNoBynoHouseNumberHandler(newVal, type) {
      if (type === 'shipper') {
        this.addressForm.shipperStreetNo = newVal ? 'N/A' : ''
      } else if (type === 'consignee') {
        this.addressForm.consigneeStreetNo = newVal ? 'N/A' : ''
      } else if (type === 'seller') {
        this.addressForm.sellerStreetNo = newVal ? 'N/A' : ''
      } else if (type === 'buyer') {
        this.addressForm.buyerStreetNo = newVal ? 'N/A' : ''
      }
    },
    syncCheckMbl(newCarrierEori) {
      // 如果没有 mbl 值或没有 carrierEori，不需要校验
      if (!this.form.mbl || !newCarrierEori) return

      const mblRules = {
        'DK32345794': {
          prefix: 'MAEU',
          allowed: false,
          message: 'MBL No 不可以为 MAEU 开头'
        },
        'FR56202442200486': {
          prefix: 'CMDU',
          allowed: false,
          message: 'MBL No 不可以为 CMDU 开头'
        },
        'DE7759959': {
          prefix: 'COSU',
          allowed: false,
          numberOnly: true,
          message: 'MBL 不可以为 COSU 开头且必须是纯数字'
        },
        'DE6982379': {
          prefix: 'EGLV',
          allowed: false,
          numberOnly: true,
          message: 'MBL 不可以为 EGLV 开头且必须是纯数字'
        },
        'DE5390214': {
          prefix: 'HDMU',
          allowed: false,
          message: 'MBL 不可以为 HDMU 开头'
        },
        'DE2742004': {
          prefix: 'HLCU',
          required: true,
          message: 'MBL 必须为 HLCU 开头'
        },
        'FR39054982200083': {
          prefix: 'MEDU',
          required: true,
          message: 'MBL 必须为 MEDU 开头'
        },
        'BEGB000109': {
          prefix: 'ONEY',
          required: true,
          message: 'MBL 必须为 ONEY 开头'
        },
        'NL821606931': {
          prefix: 'OOLU',
          allowed: false,
          numberOnly: true,
          message: 'MBL 不可以为 OOLU 开头且必须是纯数字'
        },
        'NL825860003': {
          prefix: 'OOLU',
          allowed: false,
          numberOnly: true,
          message: 'MBL 不可以为 OOLU 开头且必须是纯数字'
        },
        'NL805314696': {
          prefixes: ['YMLU', 'YMJA'],
          allowed: false,
          message: 'MBL 不可以为 YMLU 开头也不可以为 YMJA 开头'
        },
        'DE7093837': {
          prefix: 'ZIMU',
          required: true,
          message: 'MBL 必须为 ZIMU 开头'
        }
      }

      const rule = mblRules[newCarrierEori]
      if (!rule) return

      const currentMbl = this.form.mbl

      // 检查规则并给出提示
      if (rule.required && !currentMbl.startsWith(rule.prefix)) {
        this.$message.warning(rule.message)
      } else if (rule.allowed === false) {
        if (rule.prefixes) {
          // 多个禁止前缀
          for (const prefix of rule.prefixes) {
            if (currentMbl.startsWith(prefix)) {
              this.$message.warning(rule.message)
              break
            }
          }
        } else if (currentMbl.startsWith(rule.prefix)) {
          this.$message.warning(rule.message)
        }
      }

      // 检查纯数字要求
      if (rule.numberOnly && !/^\d+$/.test(currentMbl)) {
        this.$message.warning(rule.message)
      }
    },
    updateCargoTypeByEnsCargoInfo(newVal) {
      // cargo Type字段----原本是枚举值用户选择，现在改成根据用户信息来判断，如果用户任意品名信息中填写了DGUN字段，则货物类型为 DG，如果任意货物信息中填写了CUS No，则为Chemical
      // 如果没有货物信息，默认为普通货物(0)
      if (!this.form.ensCargoInfo || !this.form.ensCargoInfo?.length) {
        this.form.goodsType = 0
        return
      }

      // 使用 some 方法进行快速判断
      if (this.form.ensCargoInfo.some(item => item.undgCode)) {
        this.form.goodsType = 1 // DG货物
      } else if (this.form.ensCargoInfo.some(item => item.cusCode)) {
        this.form.goodsType = 2 // Chemical货物
      } else {
        this.form.goodsType = 0 // 普通货物
      }
    },
    customLabelHandler(field, item) {
      switch (field) {
        case 'Carrier':
          return !item ? '' : this.isChineseLanguage ? `${item.shipCompanyCode} | ${item.carrierEori} | ${item.shipCompanyEnglishName} | ${item.shipCompanyChineseName}` : `${item.shipCompanyCode} | ${item.carrierEori} | ${item.shipCompanyEnglishName}`
        case 'Declarant':
          return !item ? '' : this.isChineseLanguage ? `${item.eori} | ${item.name}` : `${item.eori} | ${item.name}`
        case 'Memberstate':
          return !item ? '' : this.isChineseLanguage ? `${item.code} | ${item.name} | ${item.chineseName}` : `${item.code} | ${item.name}`
        case 'Declare Type':
          return !item ? '' : this.isChineseLanguage ? `${item.englishName} ｜ ${item.chineseName}` : `${item.englishName}`
        case 'Payment Method':
          return !item ? '' : this.isChineseLanguage ? `${item.englishName} | ${item.chineseName}` : `${item.englishName}`
        case 'Place of Loading':
          return !item ? '' : `${item.code} | ${item.englishName}`
        case 'Country':
          return !item ? '' : this.isChineseLanguage ? `${item.code} | ${item.name} | ${item.chineseName} ` : `${item.code} | ${item.name}`
      }
    },
    validateMBL(value) {
      if (!value) return ''

      // 1. 转大写并过滤不合规字符(只保留大写字母、数字、短横杠、斜杠)
      let formattedValue = value.toUpperCase().replace(/[^A-Z0-9\-/]/g, '')

      // 2. 限制长度为30个字符
      formattedValue = formattedValue.slice(0, 30)

      // 3. 更新表单值
      this.form.mbl = formattedValue

      // 4. 根据船公司EORI进行校验
      this.syncCheckMbl(this.form.carrierEori)
    },
    // 更新总计
    updateTotals() {
      if (!this.form.ensCargoInfo || !this.form.ensCargoInfo.length) {
        this.calculatedTotals.quantity = 0
        this.calculatedTotals.weight = '0'
        return
      }

      this.calculatedTotals.quantity = this.form.ensCargoInfo.reduce((sum, item) => {
        return sum + (Number(item.quantity) || 0)
      }, 0)

      let totalWeight = this.form.ensCargoInfo.reduce((sum, item) => {
        return sum + parseFloat(item.weight)
      }, 0)
      totalWeight = NumberUtils.ToFixed2(totalWeight, 6)
      if (totalWeight <= 0) {
        this.calculatedTotals.weight = 0
      } else {
        this.calculatedTotals.weight = ColumnUtils.formatNumber(totalWeight, 6, false, false, false)
      }
    },
    formatWeightHandler(value) {
      let valueWeight = value
      if (value > 999999999.999999) {
        valueWeight = 999999999.999999
      }
      if (value <= 0) {
        valueWeight = 0
        return 0
      }
      return ColumnUtils.formatNumber(valueWeight, 6, false, false, false)
    },
    validColumn(field, params) {
      switch (field) {
        case 'hblNbr2':
          if (params.newValue) {
            // 转大写并过滤不合规字符
            const valueHblNbr2 = params.newValue
              .toUpperCase()
              .replace(/[^A-Z0-9\-/]/g, '')
              .slice(0, 30) // 限制长度为30

            if (valueHblNbr2 !== params.newValue) {
              // 如果值被格式化，更新单元格的值
              params.node.setDataValue(params.column.colId, valueHblNbr2)
            }
          }
          break
        case 'containerNo':
          if (!params.newValue) return

          // 转大写并过滤不合规字符
          let valueContainerNo = params.newValue
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, '')
            .slice(0, 11)

          // 检查第4位是否为U
          if (valueContainerNo.length >= 4 && valueContainerNo[3] !== 'U') {
            valueContainerNo = valueContainerNo.slice(0, 3) + 'U' + valueContainerNo.slice(4)
          }

          // 补全或截断到11位
          if (valueContainerNo.length < 11) {
            valueContainerNo = valueContainerNo.padEnd(11, '0')
          } else {
            valueContainerNo = valueContainerNo.slice(0, 11)
          }

          // 如果值被格式化，更新单元格的值
          if (valueContainerNo !== params.newValue) {
            params.node.setDataValue(params.column.colId, valueContainerNo)
          }
          break
        case 'hsCode':
          if (!params.newValue) {
            this.$message.warning(this.$t('SeaExport.HscodeCannotBeEmpty'))
            return
          }

          // 过滤不合规字符，只保留数字
          let valueHsCode = params.newValue
            .replace(/[^\d]/g, '')
            .slice(0, 6) // 限制长度为6位

          // 补全到6位
          if (valueHsCode.length < 6) {
            valueHsCode = valueHsCode.padEnd(6, '0')
          }

          // 如果值被格式化，更新单元格的值
          if (valueHsCode !== params.newValue) {
            params.node.setDataValue(params.column.colId, valueHsCode)
          }
          break
        case 'mark':
          if (!params.newValue) return

          // 过滤不合规字符，只保留合规字符：大小写字母、数字、短横杠、斜杠、逗号、空格、冒号、引号、加号、下划线
          const valueMark = params.newValue
            .replace(/[^a-zA-Z0-9"\-/,: '_"+]/g, '')
            .slice(0, 512) // 限制长度为512个字符

          // 如果值被格式化，更新单元格的值
          if (valueMark !== params.newValue) {
            params.node.setDataValue(params.column.colId, valueMark)
          }
          break
        case 'cargoEnglishName':
          if (!params.newValue) return

          // 过滤不合规字符，只保留合规字符：大小写字母、数字、短横杠、斜杠、逗号、空格、冒号、引号、加号、下划线
          const valueCargoEnglishName = params.newValue
            .replace(/[^a-zA-Z0-9"\-/,: '_"+]/g, '')
            .slice(0, 512) // 限制长度为512个字符

          // 如果值被格式化，更新单元格的值
          if (valueCargoEnglishName !== params.newValue) {
            params.node.setDataValue(params.column.colId, valueCargoEnglishName)
          }
          break
        case 'quantity':
          if (!params.newValue) {
            this.updateTotals()
            return
          }

          let valueQuantity = params.newValue
          if (params.newValue > 99999999) {
            valueQuantity = 99999999
          }
          if (params.newValue <= 0) {
            valueQuantity = 0
          }

          // 如果值被格式化，更新单元格的值
          if (valueQuantity !== params.newValue) {
            params.node.setDataValue(params.column.colId, valueQuantity)
          }

          this.updateTotals()
          break
        case 'weight':
          if (!params.newValue) {
            this.updateTotals()
            return
          }
          params.data.weight = this.formatWeightHandler(params.newValue)
          this.updateTotals()
          break
        case 'undgCode':
          if (!params.newValue) return
          // 验证是否为4位纯数字
          if (!/^\d{4}$/.test(params.newValue)) {
            const tip = this.isChineseLanguage ? 'UN CODE必须是4位数字' : 'The UN CODE must be 4 digits'
            this.$message.warning(tip)
          }
          break
        case 'cusCode':
          if (!params.newValue) return

          // 过滤不合规字符，只保留数字和短横杠
          let valueCusCode = params.newValue
            .replace(/[^\d-]/g, '')

          // 确保格式为 NNNNNNN-N
          if (valueCusCode.length > 0) {
            // 先提取所有数字
            const numbers = valueCusCode.replace(/[^0-9]/g, '')
            if (numbers.length >= 8) {
              // 格式化为 NNNNNNN-N
              valueCusCode = numbers.slice(0, 7) + '-' + numbers.slice(7, 8)
            } else {
              // 不足8位数字时，用0补全
              valueCusCode = numbers.padEnd(7, '0') + '-' + (numbers[7] || '0')
            }
          }

          // 如果值被格式化，更新单元格的值
          if (valueCusCode !== params.newValue) {
            params.node.setDataValue(params.column.colId, valueCusCode)
          }
          break
        case 'eori':
          if (!params.newValue) return

          // 先转换为大写
          let valueEori = params.newValue.toUpperCase()

          // 过滤不合规字符，只保留大写字母和数字
          valueEori = valueEori
            .replace(/[^A-Z0-9]/g, '')
            .slice(0, 17) // 限制长度为17个字符

          // 如果值被格式化，更新单元格的值
          if (valueEori !== params.newValue) {
            params.node.setDataValue(params.column.colId, valueEori)
          }
          break
      }
    },
    validAddressForm() {
      // 发货人信息验证
      this.validInput('shipperLine1')
      this.validInput('shipperLine3')
      this.validInput('shipperLine4')
      this.validInput('shipperStreetNo')
      this.validInput('shipperPostalcode')
      this.validInput('shipperCity')
      this.validInput('shipperTel')

      // 收货人信息验证
      this.validInput('consigneeLine1')
      this.validInput('consigneeLine3')
      this.validInput('consigneeLine4')
      this.validInput('consigneeStreetNo')
      this.validInput('consigneePostalcode')
      this.validInput('consigneeCity')
      this.validInput('consigneeTel')

      // 卖家信息验证
      this.validInput('sellerName')
      this.validInput('sellerAddress1')
      this.validInput('sellerAddress2')
      this.validInput('sellerStreetNo')
      this.validInput('sellerPostalcode')
      this.validInput('sellerCity')
      this.validInput('sellerTel')

      // 买家信息验证
      this.validInput('buyerName')
      this.validInput('buyerAddress1')
      this.validInput('buyerAddress2')
      this.validInput('buyerStreetNo')
      this.validInput('buyerPostalcode')
      this.validInput('buyerCity')
      this.validInput('buyerTel')
    },
    validInput(field) {
      // 如果字段值为空，直接返回
      if (!this.addressForm[field]) return

      // 验证规则配置
      const validationRules = {
        // 名称和地址字段规则
        nameAndAddress: {
          fields: [
            'shipperLine1', 'shipperLine3', 'shipperLine4',
            'consigneeLine1', 'consigneeLine3', 'consigneeLine4',
            'sellerName', 'sellerAddress1', 'sellerAddress2',
            'buyerName', 'buyerAddress1', 'buyerAddress2'
          ],
          pattern: /[^a-zA-Z0-9"\-/,: '_"+]/g,
          maxLength: 70,
          transform: value => value
        },

        // 街道号和邮编规则
        streetNoAndPostal: {
          fields: [
            'shipperStreetNo', 'shipperPostalcode',
            'consigneeStreetNo', 'consigneePostalcode',
            'sellerStreetNo', 'sellerPostalcode',
            'buyerStreetNo', 'buyerPostalcode'
          ],
          pattern: /[^A-Z0-9 /-]/g,
          maxLength: 10,
          transform: value => value.toUpperCase()
        },

        // 城市规则
        city: {
          fields: [
            'shipperCity', 'consigneeCity',
            'sellerCity', 'buyerCity'
          ],
          pattern: /[^A-Z0-9 /-]/g,
          maxLength: 35,
          transform: value => value.toUpperCase()
        },

        // 电话规则
        telephone: {
          fields: [
            'shipperTel', 'consigneeTel',
            'sellerTel', 'buyerTel'
          ],
          pattern: /[^+\d \-]/g,
          transform: value => value
        },

        // 邮箱规则
        email: {
          fields: [
            'shipperEmail', 'consigneeEmail',
            'sellerEmail', 'buyerEmail'
          ],
          pattern: /[^a-zA-Z0-9+@ \-_.]/g,
          transform: value => value
        },

        // EORI规则
        eori: {
          fields: [
            'shipperEori', 'consigneeEori',
            'sellerEori', 'buyerEori'
          ],
          pattern: /[^A-Z0-9]/g,
          maxLength: 17,
          transform: value => value.toUpperCase()
        }
      }

      // 查找适用的规则
      const rule = Object.values(validationRules).find(r => r.fields.includes(field))
      if (!rule) return

      // 应用验证规则
      let value = rule.transform(this.addressForm[field])
      value = value.replace(rule.pattern, '')
      if (rule.maxLength) {
        value = value.slice(0, rule.maxLength)
      }

      // 如果值发生变化，更新表单
      if (value !== this.addressForm[field]) {
        this.addressForm[field] = value
      }
    },
    carrierEoriChange(data) {
      this.form.carrierEori = data.carrierEori
    },
    declarantEoriChange(data) {
      this.form.declarantEori = data.eori
      // 申报人也就是承运人相关赋值
      this.addressForm.carrierEori = data.eori
      this.addressForm.carrierName = data.name
      this.addressForm.carrierAddress1 = data.address1
      this.addressForm.carrierAddress2 = data.address2
      this.addressForm.carrierStreetNo = data.streetNo
      this.addressForm.carrierPostalcode = data.postalcode
      this.addressForm.carrierEmail = data.email
      this.addressForm.carrierTel = data.tel
      this.addressForm.carrierCountry = data.country
      this.addressForm.carrierCity = data.city
    },
    aiRecognitionPostRefreshListHandler() {
      if (this.container) {
        this.container.gridOptions.api.clearFocusedCell()
        this.container.gridOptions.api.refreshCells({ force: true })
      }

      if (this.cargoInfomation) {
        this.gridApi3.setRowData(this.form.ensCargoInfo)
        this.cargoInfomation.gridOptions.api.clearFocusedCell()
        this.cargoInfomation.gridOptions.api.refreshCells({ force: true })
      }

      // 刷新合计数据
      this.updateTotals()

      // 刷新箱子序号
      this.pm.synclinkedCargoSerialNumber()
      return ''
    }
  }
}
</script>

<style lang="scss">
  .ams-info{
    .warning .el-input__inner{
      color: red !important;
    }
    .warning{
      color: red !important;
    }
    .el-radio__label{
      font-size: 12px;
      font-weight: normal;
      color: #333333 !important;
    }
    .el-checkbox__label{
      font-weight: normal;
      color: #333333 !important;
    }
  }
  .custom-label {
    width: 300px !important; /* 设置 label 的固定宽度 */
  }
  .blue-text{
    color: #1f75d5 !important;
  }
  .address-format-from{
    .center-label{
      margin-left: 5px;
      margin-right: 5px;
      width: 110px;
    }
  }

  /* 圆点样式 */
  .status-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 5px;
  }

  .status-dot-green::before {
    content: ""; /* 伪元素必须设置 content */
    display: inline-block;
    vertical-align: middle;
    width: 15px; /* 圆点的宽度 */
    height: 15px; /* 圆点的高度 */
    background-color: #2B7102; /* 圆点的颜色 */
    border-radius: 50%; /* 圆点的形状 */
    margin-right: 10px; /* 圆点与文字的间距 */
    position: relative; /* 添加相对定位 */
    top: -2px; /* 微调垂直位置以实现更精确的居中 */
  }

  .status-dot-red::before {
    content: ""; /* 伪元素必须设置 content */
    display: inline-block;
    vertical-align: middle;
    width: 15px; /* 圆点的宽度 */
    height: 15px; /* 圆点的高度 */
    background-color: #E23426; /* 圆点的颜色 */
    border-radius: 50%; /* 圆点的形状 */
    margin-right: 10px; /* 圆点与文字的间距 */
    position: relative; /* 添加相对定位 */
    top: -2px; /* 微调垂直位置以实现更精确的居中 */
  }
  .status-dot-yellow::before {
    content: ""; /* 伪元素必须设置 content */
    display: inline-block;
    vertical-align: middle;
    width: 15px; /* 圆点的宽度 */
    height: 15px; /* 圆点的高度 */
    background-color: #F9DF04; /* 圆点的颜色 */
    border-radius: 50%; /* 圆点的形状 */
    margin-right: 10px; /* 圆点与文字的间距 */
    position: relative; /* 添加相对定位 */
    top: -2px; /* 微调垂直位置以实现更精确的居中 */
  }
  .status-dot-gray::before {
    content: ""; /* 伪元素必须设置 content */
    display: inline-block;
    vertical-align: middle;
    width: 15px; /* 圆点的宽度 */
    height: 15px; /* 圆点的高度 */
    background-color: #6F6F6F; /* 圆点的颜色 */
    border-radius: 50%; /* 圆点的形状 */
    margin-right: 10px; /* 圆点与文字的间距 */
    position: relative; /* 添加相对定位 */
    top: -2px; /* 微调垂直位置以实现更精确的居中 */
  }
</style>
